import Vue from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var vueMultiselect_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
     module.exports = e() ;
  }(commonjsGlobal, function () {
    return function (t) {
      function e(r) {
        if (n[r]) return n[r].exports;
        var i = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
      }

      var n = {};
      return e.m = t, e.c = n, e.i = function (t) {
        return t;
      }, e.d = function (t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, e.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, "a", n), n;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "/", e(e.s = 92);
    }([function (t, e, n) {
      var r = n(3),
          i = n(43),
          o = n(10),
          s = n(11),
          u = n(44),
          a = function (t, e, n) {
        var c,
            l,
            f,
            p,
            h = t & a.F,
            d = t & a.G,
            v = t & a.S,
            y = t & a.P,
            g = t & a.B,
            m = d ? r : v ? r[e] || (r[e] = {}) : (r[e] || {}).prototype,
            b = d ? i : i[e] || (i[e] = {}),
            x = b.prototype || (b.prototype = {});
        d && (n = e);

        for (c in n) l = !h && m && void 0 !== m[c], f = (l ? m : n)[c], p = g && l ? u(f, r) : y && "function" == typeof f ? u(Function.call, f) : f, m && s(m, c, f, t & a.U), b[c] != f && o(b, c, p), y && x[c] != f && (x[c] = f);
      };

      r.core = i, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
    }, function (t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (t, e, n) {
      t.exports = !n(9)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function () {
            return 7;
          }
        }).a;
      });
    }, function (t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (t, e, n) {
      var r = n(51)("wks"),
          i = n(55),
          o = n(3).Symbol,
          s = "function" == typeof o;
      (t.exports = function (t) {
        return r[t] || (r[t] = s && o[t] || (s ? o : i)("Symbol." + t));
      }).store = r;
    }, function (t, e, n) {
      t.exports = !n(21)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function () {
            return 7;
          }
        }).a;
      });
    }, function (t, e) {
      var n = {}.hasOwnProperty;

      t.exports = function (t, e) {
        return n.call(t, e);
      };
    }, function (t, e, n) {
      var r = n(20),
          i = n(62),
          o = n(39),
          s = Object.defineProperty;
      e.f = n(5) ? Object.defineProperty : function (t, e, n) {
        if (r(t), e = o(e, !0), r(n), i) try {
          return s(t, e, n);
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      };
    }, function (t, e, n) {
      var r = n(16);

      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    }, function (t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    }, function (t, e, n) {
      var r = n(19),
          i = n(49);
      t.exports = n(2) ? function (t, e, n) {
        return r.f(t, e, i(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    }, function (t, e, n) {
      var r = n(3),
          i = n(10),
          o = n(15),
          s = n(55)("src"),
          u = n(127),
          a = ("" + u).split("toString");
      n(43).inspectSource = function (t) {
        return u.call(t);
      }, (t.exports = function (t, e, n, u) {
        var c = "function" == typeof n;
        c && (o(n, "name") || i(n, "name", e)), t[e] !== n && (c && (o(n, s) || i(n, s, t[e] ? "" + t[e] : a.join(String(e)))), t === r ? t[e] = n : u ? t[e] ? t[e] = n : i(t, e, n) : (delete t[e], i(t, e, n)));
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && this[s] || u.call(this);
      });
    }, function (t, e, n) {
      var r = n(7),
          i = n(23);
      t.exports = n(5) ? function (t, e, n) {
        return r.f(t, e, i(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    }, function (t, e, n) {
      var r = n(102),
          i = n(29);

      t.exports = function (t) {
        return r(i(t));
      };
    }, function (t, e, n) {
      var r = n(37)("wks"),
          i = n(24),
          o = n(1).Symbol,
          s = "function" == typeof o;
      (t.exports = function (t) {
        return r[t] || (r[t] = s && o[t] || (s ? o : i)("Symbol." + t));
      }).store = r;
    }, function (t, e) {
      var n = {}.hasOwnProperty;

      t.exports = function (t, e) {
        return n.call(t, e);
      };
    }, function (t, e) {
      t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
      };
    }, function (t, e) {
      var n = t.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    }, function (t, e) {
      t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
      };
    }, function (t, e, n) {
      var r = n(8),
          i = n(74),
          o = n(54),
          s = Object.defineProperty;
      e.f = n(2) ? Object.defineProperty : function (t, e, n) {
        if (r(t), e = o(e, !0), r(n), i) try {
          return s(t, e, n);
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      };
    }, function (t, e, n) {
      var r = n(18);

      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    }, function (t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    }, function (t, e) {
      t.exports = !0;
    }, function (t, e) {
      t.exports = function (t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    }, function (t, e) {
      var n = 0,
          r = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
      };
    }, function (t, e) {
      var n = {}.toString;

      t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    }, function (t, e) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    }, function (t, e, n) {

      var r = n(9);

      t.exports = function (t, e) {
        return !!t && r(function () {
          e ? t.call(null, function () {}, 1) : t.call(null);
        });
      };
    }, function (t, e, n) {
      var r = n(47),
          i = n(26);

      t.exports = function (t) {
        return r(i(t));
      };
    }, function (t, e) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    }, function (t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (t, e, n) {
      var r = n(1),
          i = n(17),
          o = n(99),
          s = n(12),
          u = n(6),
          a = function (t, e, n) {
        var c,
            l,
            f,
            p = t & a.F,
            h = t & a.G,
            d = t & a.S,
            v = t & a.P,
            y = t & a.B,
            g = t & a.W,
            m = h ? i : i[e] || (i[e] = {}),
            b = m.prototype,
            x = h ? r : d ? r[e] : (r[e] || {}).prototype;
        h && (n = e);

        for (c in n) (l = !p && x && void 0 !== x[c]) && u(m, c) || (f = l ? x[c] : n[c], m[c] = h && "function" != typeof x[c] ? n[c] : y && l ? o(f, r) : g && x[c] == f ? function (t) {
          var e = function (e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(e);

                case 2:
                  return new t(e, n);
              }

              return new t(e, n, r);
            }

            return t.apply(this, arguments);
          };

          return e.prototype = t.prototype, e;
        }(f) : v && "function" == typeof f ? o(Function.call, f) : f, v && ((m.virtual || (m.virtual = {}))[c] = f, t & a.R && b && !b[c] && s(b, c, f)));
      };

      a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
    }, function (t, e) {
      t.exports = {};
    }, function (t, e, n) {
      var r = n(67),
          i = n(30);

      t.exports = Object.keys || function (t) {
        return r(t, i);
      };
    }, function (t, e) {
      e.f = {}.propertyIsEnumerable;
    }, function (t, e, n) {
      var r = n(7).f,
          i = n(6),
          o = n(14)("toStringTag");

      t.exports = function (t, e, n) {
        t && !i(t = n ? t : t.prototype, o) && r(t, o, {
          configurable: !0,
          value: e
        });
      };
    }, function (t, e, n) {
      var r = n(37)("keys"),
          i = n(24);

      t.exports = function (t) {
        return r[t] || (r[t] = i(t));
      };
    }, function (t, e, n) {
      var r = n(17),
          i = n(1),
          o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
      (t.exports = function (t, e) {
        return o[t] || (o[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: r.version,
        mode: n(22) ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    }, function (t, e) {
      var n = Math.ceil,
          r = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
      };
    }, function (t, e, n) {
      var r = n(18);

      t.exports = function (t, e) {
        if (!r(t)) return t;
        var n, i;
        if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
        if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (t, e, n) {
      var r = n(1),
          i = n(17),
          o = n(22),
          s = n(41),
          u = n(7).f;

      t.exports = function (t) {
        var e = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
        "_" == t.charAt(0) || t in e || u(e, t, {
          value: s.f(t)
        });
      };
    }, function (t, e, n) {
      e.f = n(14);
    }, function (t, e, n) {
      var r = n(44),
          i = n(47),
          o = n(53),
          s = n(52),
          u = n(124);

      t.exports = function (t, e) {
        var n = 1 == t,
            a = 2 == t,
            c = 3 == t,
            l = 4 == t,
            f = 6 == t,
            p = 5 == t || f,
            h = e || u;
        return function (e, u, d) {
          for (var v, y, g = o(e), m = i(g), b = r(u, d, 3), x = s(m.length), _ = 0, O = n ? h(e, x) : a ? h(e, 0) : void 0; x > _; _++) if ((p || _ in m) && (v = m[_], y = b(v, _, g), t)) if (n) O[_] = y;else if (y) switch (t) {
            case 3:
              return !0;

            case 5:
              return v;

            case 6:
              return _;

            case 2:
              O.push(v);
          } else if (l) return !1;

          return f ? -1 : c || l ? l : O;
        };
      };
    }, function (t, e) {
      var n = t.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    }, function (t, e, n) {
      var r = n(70);

      t.exports = function (t, e, n) {
        if (r(t), void 0 === e) return t;

        switch (n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };

          case 2:
            return function (n, r) {
              return t.call(e, n, r);
            };

          case 3:
            return function (n, r, i) {
              return t.call(e, n, r, i);
            };
        }

        return function () {
          return t.apply(e, arguments);
        };
      };
    }, function (t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (t, e, n) {

      var r = n(8);

      t.exports = function () {
        var t = r(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
      };
    }, function (t, e, n) {
      var r = n(25);
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == r(t) ? t.split("") : Object(t);
      };
    }, function (t, e) {
      t.exports = {};
    }, function (t, e) {
      t.exports = function (t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    }, function (t, e, n) {
      var r = n(51)("keys"),
          i = n(55);

      t.exports = function (t) {
        return r[t] || (r[t] = i(t));
      };
    }, function (t, e, n) {
      var r = n(43),
          i = n(3),
          o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
      (t.exports = function (t, e) {
        return o[t] || (o[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: r.version,
        mode: n(76) ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    }, function (t, e, n) {
      var r = n(84),
          i = Math.min;

      t.exports = function (t) {
        return t > 0 ? i(r(t), 9007199254740991) : 0;
      };
    }, function (t, e, n) {
      var r = n(26);

      t.exports = function (t) {
        return Object(r(t));
      };
    }, function (t, e, n) {
      var r = n(16);

      t.exports = function (t, e) {
        if (!r(t)) return t;
        var n, i;
        if (e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        if ("function" == typeof (n = t.valueOf) && !r(i = n.call(t))) return i;
        if (!e && "function" == typeof (n = t.toString) && !r(i = n.call(t))) return i;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (t, e) {
      var n = 0,
          r = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
      };
    }, function (t, e, n) {

      var r = n(3),
          i = n(15),
          o = n(25),
          s = n(129),
          u = n(54),
          a = n(9),
          c = n(134).f,
          l = n(78).f,
          f = n(19).f,
          p = n(83).trim,
          h = r.Number,
          d = h,
          v = h.prototype,
          y = "Number" == o(n(77)(v)),
          g = ("trim" in String.prototype),
          m = function (t) {
        var e = u(t, !1);

        if ("string" == typeof e && e.length > 2) {
          e = g ? e.trim() : p(e, 3);
          var n,
              r,
              i,
              o = e.charCodeAt(0);

          if (43 === o || 45 === o) {
            if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
          } else if (48 === o) {
            switch (e.charCodeAt(1)) {
              case 66:
              case 98:
                r = 2, i = 49;
                break;

              case 79:
              case 111:
                r = 8, i = 55;
                break;

              default:
                return +e;
            }

            for (var s, a = e.slice(2), c = 0, l = a.length; c < l; c++) if ((s = a.charCodeAt(c)) < 48 || s > i) return NaN;

            return parseInt(a, r);
          }
        }

        return +e;
      };

      if (!h(" 0o1") || !h("0b1") || h("+0x1")) {
        h = function (t) {
          var e = arguments.length < 1 ? 0 : t,
              n = this;
          return n instanceof h && (y ? a(function () {
            v.valueOf.call(n);
          }) : "Number" != o(n)) ? s(new d(m(e)), n, h) : m(e);
        };

        for (var b, x = n(2) ? c(d) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), _ = 0; x.length > _; _++) i(d, b = x[_]) && !i(h, b) && f(h, b, l(d, b));

        h.prototype = v, v.constructor = h, n(11)(r, "Number", h);
      }
    }, function (t, e, n) {

      function r(t) {
        return 0 !== t && (!(!Array.isArray(t) || 0 !== t.length) || !t);
      }

      function i(t) {
        return function () {
          return !t.apply(void 0, arguments);
        };
      }

      function o(t, e) {
        return void 0 === t && (t = "undefined"), null === t && (t = "null"), !1 === t && (t = "false"), -1 !== t.toString().toLowerCase().indexOf(e.trim());
      }

      function s(t, e, n, r) {
        return t.filter(function (t) {
          return o(r(t, n), e);
        });
      }

      function u(t) {
        return t.filter(function (t) {
          return !t.$isLabel;
        });
      }

      function a(t, e) {
        return function (n) {
          return n.reduce(function (n, r) {
            return r[t] && r[t].length ? (n.push({
              $groupLabel: r[e],
              $isLabel: !0
            }), n.concat(r[t])) : n;
          }, []);
        };
      }

      function c(t, e, r, i, o) {
        return function (u) {
          return u.map(function (u) {
            var a;
            if (!u[r]) return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
            var c = s(u[r], t, e, o);
            return c.length ? (a = {}, n.i(d.a)(a, i, u[i]), n.i(d.a)(a, r, c), a) : [];
          });
        };
      }

      var l = n(91),
          f = n(85),
          p = (n.n(f), n(151)),
          h = (n.n(p), n(56)),
          d = (n.n(h), n(90)),
          v = n(146),
          y = (n.n(v), n(154)),
          g = (n.n(y), n(147)),
          m = (n.n(g), n(142)),
          b = (n.n(m), n(153)),
          x = (n.n(b), n(143)),
          _ = (n.n(x), n(152)),
          O = (n.n(_), n(148)),
          S = (n.n(O), n(144)),
          w = (n.n(S), function () {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];

        return function (t) {
          return e.reduce(function (t, e) {
            return e(t);
          }, t);
        };
      });

      e.a = {
        data: function () {
          return {
            search: "",
            isOpen: !1,
            preferredOpenDirection: "below",
            optimizedHeight: this.maxHeight
          };
        },
        props: {
          internalSearch: {
            type: Boolean,
            default: !0
          },
          options: {
            type: Array,
            required: !0
          },
          multiple: {
            type: Boolean,
            default: !1
          },
          value: {
            type: null,
            default: function () {
              return [];
            }
          },
          trackBy: {
            type: String
          },
          label: {
            type: String
          },
          searchable: {
            type: Boolean,
            default: !0
          },
          clearOnSelect: {
            type: Boolean,
            default: !0
          },
          hideSelected: {
            type: Boolean,
            default: !1
          },
          placeholder: {
            type: String,
            default: "Select option"
          },
          allowEmpty: {
            type: Boolean,
            default: !0
          },
          resetAfter: {
            type: Boolean,
            default: !1
          },
          closeOnSelect: {
            type: Boolean,
            default: !0
          },
          customLabel: {
            type: Function,
            default: function (t, e) {
              return r(t) ? "" : e ? t[e] : t;
            }
          },
          taggable: {
            type: Boolean,
            default: !1
          },
          tagPlaceholder: {
            type: String,
            default: "Press enter to create a tag"
          },
          tagPosition: {
            type: String,
            default: "top"
          },
          max: {
            type: [Number, Boolean],
            default: !1
          },
          id: {
            default: null
          },
          optionsLimit: {
            type: Number,
            default: 1e3
          },
          groupValues: {
            type: String
          },
          groupLabel: {
            type: String
          },
          groupSelect: {
            type: Boolean,
            default: !1
          },
          blockKeys: {
            type: Array,
            default: function () {
              return [];
            }
          },
          preserveSearch: {
            type: Boolean,
            default: !1
          },
          preselectFirst: {
            type: Boolean,
            default: !1
          }
        },
        mounted: function () {
          !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
        },
        computed: {
          internalValue: function () {
            return this.value || 0 === this.value ? Array.isArray(this.value) ? this.value : [this.value] : [];
          },
          filteredOptions: function () {
            var t = this.search || "",
                e = t.toLowerCase().trim(),
                n = this.options.concat();
            return n = this.internalSearch ? this.groupValues ? this.filterAndFlat(n, e, this.label) : s(n, e, this.label, this.customLabel) : this.groupValues ? a(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(i(this.isSelected)) : n, this.taggable && e.length && !this.isExistingOption(e) && ("bottom" === this.tagPosition ? n.push({
              isTag: !0,
              label: t
            }) : n.unshift({
              isTag: !0,
              label: t
            })), n.slice(0, this.optionsLimit);
          },
          valueKeys: function () {
            var t = this;
            return this.trackBy ? this.internalValue.map(function (e) {
              return e[t.trackBy];
            }) : this.internalValue;
          },
          optionKeys: function () {
            var t = this;
            return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function (e) {
              return t.customLabel(e, t.label).toString().toLowerCase();
            });
          },
          currentOptionLabel: function () {
            return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
          }
        },
        watch: {
          internalValue: function () {
            this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
          },
          search: function () {
            this.$emit("search-change", this.search, this.id);
          }
        },
        methods: {
          getValue: function () {
            return this.multiple ? this.internalValue : 0 === this.internalValue.length ? null : this.internalValue[0];
          },
          filterAndFlat: function (t, e, n) {
            return w(c(e, n, this.groupValues, this.groupLabel, this.customLabel), a(this.groupValues, this.groupLabel))(t);
          },
          flatAndStrip: function (t) {
            return w(a(this.groupValues, this.groupLabel), u)(t);
          },
          updateSearch: function (t) {
            this.search = t;
          },
          isExistingOption: function (t) {
            return !!this.options && this.optionKeys.indexOf(t) > -1;
          },
          isSelected: function (t) {
            var e = this.trackBy ? t[this.trackBy] : t;
            return this.valueKeys.indexOf(e) > -1;
          },
          isOptionDisabled: function (t) {
            return !!t.$isDisabled;
          },
          getOptionLabel: function (t) {
            if (r(t)) return "";
            if (t.isTag) return t.label;
            if (t.$isLabel) return t.$groupLabel;
            var e = this.customLabel(t, this.label);
            return r(e) ? "" : e;
          },
          select: function (t, e) {
            if (t.$isLabel && this.groupSelect) return void this.selectGroup(t);

            if (!(-1 !== this.blockKeys.indexOf(e) || this.disabled || t.$isDisabled || t.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && ("Tab" !== e || this.pointerDirty)) {
              if (t.isTag) this.$emit("tag", t.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();else {
                if (this.isSelected(t)) return void ("Tab" !== e && this.removeElement(t));
                this.$emit("select", t, this.id), this.multiple ? this.$emit("input", this.internalValue.concat([t]), this.id) : this.$emit("input", t, this.id), this.clearOnSelect && (this.search = "");
              }
              this.closeOnSelect && this.deactivate();
            }
          },
          selectGroup: function (t) {
            var e = this,
                n = this.options.find(function (n) {
              return n[e.groupLabel] === t.$groupLabel;
            });
            if (n) if (this.wholeGroupSelected(n)) {
              this.$emit("remove", n[this.groupValues], this.id);
              var r = this.internalValue.filter(function (t) {
                return -1 === n[e.groupValues].indexOf(t);
              });
              this.$emit("input", r, this.id);
            } else {
              var i = n[this.groupValues].filter(function (t) {
                return !(e.isOptionDisabled(t) || e.isSelected(t));
              });
              this.$emit("select", i, this.id), this.$emit("input", this.internalValue.concat(i), this.id);
            }
          },
          wholeGroupSelected: function (t) {
            var e = this;
            return t[this.groupValues].every(function (t) {
              return e.isSelected(t) || e.isOptionDisabled(t);
            });
          },
          wholeGroupDisabled: function (t) {
            return t[this.groupValues].every(this.isOptionDisabled);
          },
          removeElement: function (t) {
            var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

            if (!this.disabled && !t.$isDisabled) {
              if (!this.allowEmpty && this.internalValue.length <= 1) return void this.deactivate();
              var r = "object" === n.i(l.a)(t) ? this.valueKeys.indexOf(t[this.trackBy]) : this.valueKeys.indexOf(t);

              if (this.$emit("remove", t, this.id), this.multiple) {
                var i = this.internalValue.slice(0, r).concat(this.internalValue.slice(r + 1));
                this.$emit("input", i, this.id);
              } else this.$emit("input", null, this.id);

              this.closeOnSelect && e && this.deactivate();
            }
          },
          removeLastElement: function () {
            -1 === this.blockKeys.indexOf("Delete") && 0 === this.search.length && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
          },
          activate: function () {
            var t = this;
            this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && 0 === this.pointer && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.$nextTick(function () {
              return t.$refs.search.focus();
            })) : this.$el.focus(), this.$emit("open", this.id));
          },
          deactivate: function () {
            this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search.blur() : this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
          },
          toggle: function () {
            this.isOpen ? this.deactivate() : this.activate();
          },
          adjustPosition: function () {
            if ("undefined" != typeof window) {
              var t = this.$el.getBoundingClientRect().top,
                  e = window.innerHeight - this.$el.getBoundingClientRect().bottom;
              e > this.maxHeight || e > t || "below" === this.openDirection || "bottom" === this.openDirection ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(e - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(t - 40, this.maxHeight));
            }
          }
        }
      };
    }, function (t, e, n) {

      var r = n(85),
          i = (n.n(r), n(56));
      n.n(i);
      e.a = {
        data: function () {
          return {
            pointer: 0,
            pointerDirty: !1
          };
        },
        props: {
          showPointer: {
            type: Boolean,
            default: !0
          },
          optionHeight: {
            type: Number,
            default: 40
          }
        },
        computed: {
          pointerPosition: function () {
            return this.pointer * this.optionHeight;
          },
          visibleElements: function () {
            return this.optimizedHeight / this.optionHeight;
          }
        },
        watch: {
          filteredOptions: function () {
            this.pointerAdjust();
          },
          isOpen: function () {
            this.pointerDirty = !1;
          }
        },
        methods: {
          optionHighlight: function (t, e) {
            return {
              "multiselect__option--highlight": t === this.pointer && this.showPointer,
              "multiselect__option--selected": this.isSelected(e)
            };
          },
          groupHighlight: function (t, e) {
            var n = this;
            if (!this.groupSelect) return ["multiselect__option--group", "multiselect__option--disabled"];
            var r = this.options.find(function (t) {
              return t[n.groupLabel] === e.$groupLabel;
            });
            return r && !this.wholeGroupDisabled(r) ? ["multiselect__option--group", {
              "multiselect__option--highlight": t === this.pointer && this.showPointer
            }, {
              "multiselect__option--group-selected": this.wholeGroupSelected(r)
            }] : "multiselect__option--disabled";
          },
          addPointerElement: function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Enter",
                e = t.key;
            this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
          },
          pointerForward: function () {
            this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
          },
          pointerBackward: function () {
            this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
          },
          pointerReset: function () {
            this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
          },
          pointerAdjust: function () {
            this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
          },
          pointerSet: function (t) {
            this.pointer = t, this.pointerDirty = !0;
          }
        }
      };
    }, function (t, e, n) {

      var r = n(56),
          i = (n.n(r), n(57)),
          o = n(58);
      e.a = {
        name: "vue-multiselect",
        mixins: [i.a, o.a],
        props: {
          name: {
            type: String,
            default: ""
          },
          selectLabel: {
            type: String,
            default: "Press enter to select"
          },
          selectGroupLabel: {
            type: String,
            default: "Press enter to select group"
          },
          selectedLabel: {
            type: String,
            default: "Selected"
          },
          deselectLabel: {
            type: String,
            default: "Press enter to remove"
          },
          deselectGroupLabel: {
            type: String,
            default: "Press enter to deselect group"
          },
          showLabels: {
            type: Boolean,
            default: !0
          },
          limit: {
            type: Number,
            default: 99999
          },
          maxHeight: {
            type: Number,
            default: 300
          },
          limitText: {
            type: Function,
            default: function (t) {
              return "and ".concat(t, " more");
            }
          },
          loading: {
            type: Boolean,
            default: !1
          },
          disabled: {
            type: Boolean,
            default: !1
          },
          openDirection: {
            type: String,
            default: ""
          },
          showNoOptions: {
            type: Boolean,
            default: !0
          },
          showNoResults: {
            type: Boolean,
            default: !0
          },
          tabindex: {
            type: Number,
            default: 0
          },
          searchInDropdown: {
            type: Boolean,
            default: !1
          }
        },
        computed: {
          isSingleLabelVisible: function () {
            return (this.singleValue || 0 === this.singleValue) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
          },
          isPlaceholderVisible: function () {
            return !(this.internalValue.length || this.searchable && this.isOpen);
          },
          visibleValues: function () {
            return this.multiple ? this.internalValue.slice(0, this.limit) : [];
          },
          singleValue: function () {
            return this.internalValue[0];
          },
          deselectLabelText: function () {
            return this.showLabels ? this.deselectLabel : "";
          },
          deselectGroupLabelText: function () {
            return this.showLabels ? this.deselectGroupLabel : "";
          },
          selectLabelText: function () {
            return this.showLabels ? this.selectLabel : "";
          },
          selectGroupLabelText: function () {
            return this.showLabels ? this.selectGroupLabel : "";
          },
          selectedLabelText: function () {
            return this.showLabels ? this.selectedLabel : "";
          },
          inputStyle: function () {
            if (this.searchable || this.multiple && this.value && this.value.length) return this.isOpen ? {
              width: "100%"
            } : {
              width: "0",
              position: "absolute",
              padding: "0"
            };
          },
          contentStyle: function () {
            return this.options.length ? {
              display: "inline-block"
            } : {
              display: "block"
            };
          },
          isAbove: function () {
            return "above" === this.openDirection || "top" === this.openDirection || "below" !== this.openDirection && "bottom" !== this.openDirection && "above" === this.preferredOpenDirection;
          },
          showSearchInput: function () {
            return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && 0 !== this.visibleSingleValue || this.isOpen);
          }
        }
      };
    }, function (t, e) {
      var n = {}.toString;

      t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    }, function (t, e, n) {
      var r = n(18),
          i = n(1).document,
          o = r(i) && r(i.createElement);

      t.exports = function (t) {
        return o ? i.createElement(t) : {};
      };
    }, function (t, e, n) {
      t.exports = !n(5) && !n(21)(function () {
        return 7 != Object.defineProperty(n(61)("div"), "a", {
          get: function () {
            return 7;
          }
        }).a;
      });
    }, function (t, e, n) {

      var r = n(22),
          i = n(31),
          o = n(68),
          s = n(12),
          u = n(32),
          a = n(104),
          c = n(35),
          l = n(110),
          f = n(14)("iterator"),
          p = !([].keys && "next" in [].keys()),
          h = function () {
        return this;
      };

      t.exports = function (t, e, n, d, v, y, g) {
        a(n, e, d);

        var m,
            b,
            x,
            _ = function (t) {
          if (!p && t in k) return k[t];

          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new n(this, t);
              };
          }

          return function () {
            return new n(this, t);
          };
        },
            O = e + " Iterator",
            S = "values" == v,
            w = !1,
            k = t.prototype,
            L = k[f] || k["@@iterator"] || v && k[v],
            E = L || _(v),
            P = v ? S ? _("entries") : E : void 0,
            T = "Array" == e ? k.entries || L : L;

        if (T && (x = l(T.call(new t()))) !== Object.prototype && x.next && (c(x, O, !0), r || "function" == typeof x[f] || s(x, f, h)), S && L && "values" !== L.name && (w = !0, E = function () {
          return L.call(this);
        }), r && !g || !p && !w && k[f] || s(k, f, E), u[e] = E, u[O] = h, v) if (m = {
          values: S ? E : _("values"),
          keys: y ? E : _("keys"),
          entries: P
        }, g) for (b in m) b in k || o(k, b, m[b]);else i(i.P + i.F * (p || w), e, m);
        return m;
      };
    }, function (t, e, n) {
      var r = n(20),
          i = n(107),
          o = n(30),
          s = n(36)("IE_PROTO"),
          u = function () {},
          a = function () {
        var t,
            e = n(61)("iframe"),
            r = o.length;

        for (e.style.display = "none", n(101).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), a = t.F; r--;) delete a.prototype[o[r]];

        return a();
      };

      t.exports = Object.create || function (t, e) {
        var n;
        return null !== t ? (u.prototype = r(t), n = new u(), u.prototype = null, n[s] = t) : n = a(), void 0 === e ? n : i(n, e);
      };
    }, function (t, e, n) {
      var r = n(67),
          i = n(30).concat("length", "prototype");

      e.f = Object.getOwnPropertyNames || function (t) {
        return r(t, i);
      };
    }, function (t, e) {
      e.f = Object.getOwnPropertySymbols;
    }, function (t, e, n) {
      var r = n(6),
          i = n(13),
          o = n(98)(!1),
          s = n(36)("IE_PROTO");

      t.exports = function (t, e) {
        var n,
            u = i(t),
            a = 0,
            c = [];

        for (n in u) n != s && r(u, n) && c.push(n);

        for (; e.length > a;) r(u, n = e[a++]) && (~o(c, n) || c.push(n));

        return c;
      };
    }, function (t, e, n) {
      t.exports = n(12);
    }, function (t, e, n) {
      var r = n(29);

      t.exports = function (t) {
        return Object(r(t));
      };
    }, function (t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    }, function (t, e, n) {
      var r = n(4)("unscopables"),
          i = Array.prototype;
      void 0 == i[r] && n(10)(i, r, {}), t.exports = function (t) {
        i[r][t] = !0;
      };
    }, function (t, e, n) {
      var r = n(28),
          i = n(52),
          o = n(141);

      t.exports = function (t) {
        return function (e, n, s) {
          var u,
              a = r(e),
              c = i(a.length),
              l = o(s, c);

          if (t && n != n) {
            for (; c > l;) if ((u = a[l++]) != u) return !0;
          } else for (; c > l; l++) if ((t || l in a) && a[l] === n) return t || l || 0;

          return !t && -1;
        };
      };
    }, function (t, e, n) {
      var r = n(16),
          i = n(3).document,
          o = r(i) && r(i.createElement);

      t.exports = function (t) {
        return o ? i.createElement(t) : {};
      };
    }, function (t, e, n) {
      t.exports = !n(2) && !n(9)(function () {
        return 7 != Object.defineProperty(n(73)("div"), "a", {
          get: function () {
            return 7;
          }
        }).a;
      });
    }, function (t, e, n) {
      var r = n(25);

      t.exports = Array.isArray || function (t) {
        return "Array" == r(t);
      };
    }, function (t, e) {
      t.exports = !1;
    }, function (t, e, n) {
      var r = n(8),
          i = n(133),
          o = n(45),
          s = n(50)("IE_PROTO"),
          u = function () {},
          a = function () {
        var t,
            e = n(73)("iframe"),
            r = o.length;

        for (e.style.display = "none", n(128).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), a = t.F; r--;) delete a.prototype[o[r]];

        return a();
      };

      t.exports = Object.create || function (t, e) {
        var n;
        return null !== t ? (u.prototype = r(t), n = new u(), u.prototype = null, n[s] = t) : n = a(), void 0 === e ? n : i(n, e);
      };
    }, function (t, e, n) {
      var r = n(136),
          i = n(49),
          o = n(28),
          s = n(54),
          u = n(15),
          a = n(74),
          c = Object.getOwnPropertyDescriptor;
      e.f = n(2) ? c : function (t, e) {
        if (t = o(t), e = s(e, !0), a) try {
          return c(t, e);
        } catch (t) {}
        if (u(t, e)) return i(!r.f.call(t, e), t[e]);
      };
    }, function (t, e, n) {
      var r = n(15),
          i = n(28),
          o = n(72)(!1),
          s = n(50)("IE_PROTO");

      t.exports = function (t, e) {
        var n,
            u = i(t),
            a = 0,
            c = [];

        for (n in u) n != s && r(u, n) && c.push(n);

        for (; e.length > a;) r(u, n = e[a++]) && (~o(c, n) || c.push(n));

        return c;
      };
    }, function (t, e, n) {
      var r = n(79),
          i = n(45);

      t.exports = Object.keys || function (t) {
        return r(t, i);
      };
    }, function (t, e, n) {

      var r = n(46),
          i = RegExp.prototype.exec,
          o = String.prototype.replace,
          s = i,
          u = function () {
        var t = /a/,
            e = /b*/g;
        return i.call(t, "a"), i.call(e, "a"), 0 !== t.lastIndex || 0 !== e.lastIndex;
      }(),
          a = void 0 !== /()??/.exec("")[1];

      (u || a) && (s = function (t) {
        var e,
            n,
            s,
            c,
            l = this;
        return a && (n = new RegExp("^" + l.source + "$(?!\\s)", r.call(l))), u && (e = l.lastIndex), s = i.call(l, t), u && s && (l.lastIndex = l.global ? s.index + s[0].length : e), a && s && s.length > 1 && o.call(s[0], n, function () {
          for (c = 1; c < arguments.length - 2; c++) void 0 === arguments[c] && (s[c] = void 0);
        }), s;
      }), t.exports = s;
    }, function (t, e, n) {
      var r = n(19).f,
          i = n(15),
          o = n(4)("toStringTag");

      t.exports = function (t, e, n) {
        t && !i(t = n ? t : t.prototype, o) && r(t, o, {
          configurable: !0,
          value: e
        });
      };
    }, function (t, e, n) {
      var r = n(0),
          i = n(26),
          o = n(9),
          s = n(140),
          u = "[" + s + "]",
          a = "​",
          c = RegExp("^" + u + u + "*"),
          l = RegExp(u + u + "*$"),
          f = function (t, e, n) {
        var i = {},
            u = o(function () {
          return !!s[t]() || a[t]() != a;
        }),
            c = i[t] = u ? e(p) : s[t];
        n && (i[n] = c), r(r.P + r.F * u, "String", i);
      },
          p = f.trim = function (t, e) {
        return t = String(i(t)), 1 & e && (t = t.replace(c, "")), 2 & e && (t = t.replace(l, "")), t;
      };

      t.exports = f;
    }, function (t, e) {
      var n = Math.ceil,
          r = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
      };
    }, function (t, e, n) {

      var r = n(0),
          i = n(42)(5),
          o = !0;
      "find" in [] && Array(1).find(function () {
        o = !1;
      }), r(r.P + r.F * o, "Array", {
        find: function (t) {
          return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), n(71)("find");
    }, function (t, e, n) {

      function r(t) {
        n(155);
      }

      var i = n(59),
          o = n(157),
          s = n(156),
          u = r,
          a = s(i.a, o.a, !1, u, null, null);
      e.a = a.exports;
    }, function (t, e, n) {
      t.exports = n(93);
    }, function (t, e, n) {
      t.exports = n(94);
    }, function (t, e, n) {
      t.exports = n(95);
    }, function (t, e, n) {

      function r(t, e, n) {
        return e in t ? o()(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      e.a = r;
      var i = n(87),
          o = n.n(i);
    }, function (t, e, n) {

      function r(t) {
        "@babel/helpers - typeof";

        return (r = "function" == typeof u.a && "symbol" == typeof o.a ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof u.a && t.constructor === u.a && t !== u.a.prototype ? "symbol" : typeof t;
        })(t);
      }

      e.a = r;
      var i = n(89),
          o = n.n(i),
          s = n(88),
          u = n.n(s);
    }, function (t, e, n) {

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(86),
          i = n(57),
          o = n(58);
      n.d(e, "Multiselect", function () {
        return r.a;
      }), n.d(e, "multiselectMixin", function () {
        return i.a;
      }), n.d(e, "pointerMixin", function () {
        return o.a;
      }), e.default = r.a;
    }, function (t, e, n) {
      n(115);
      var r = n(17).Object;

      t.exports = function (t, e, n) {
        return r.defineProperty(t, e, n);
      };
    }, function (t, e, n) {
      n(118), n(116), n(119), n(120), t.exports = n(17).Symbol;
    }, function (t, e, n) {
      n(117), n(121), t.exports = n(41).f("iterator");
    }, function (t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    }, function (t, e) {
      t.exports = function () {};
    }, function (t, e, n) {
      var r = n(13),
          i = n(113),
          o = n(112);

      t.exports = function (t) {
        return function (e, n, s) {
          var u,
              a = r(e),
              c = i(a.length),
              l = o(s, c);

          if (t && n != n) {
            for (; c > l;) if ((u = a[l++]) != u) return !0;
          } else for (; c > l; l++) if ((t || l in a) && a[l] === n) return t || l || 0;

          return !t && -1;
        };
      };
    }, function (t, e, n) {
      var r = n(96);

      t.exports = function (t, e, n) {
        if (r(t), void 0 === e) return t;

        switch (n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };

          case 2:
            return function (n, r) {
              return t.call(e, n, r);
            };

          case 3:
            return function (n, r, i) {
              return t.call(e, n, r, i);
            };
        }

        return function () {
          return t.apply(e, arguments);
        };
      };
    }, function (t, e, n) {
      var r = n(33),
          i = n(66),
          o = n(34);

      t.exports = function (t) {
        var e = r(t),
            n = i.f;
        if (n) for (var s, u = n(t), a = o.f, c = 0; u.length > c;) a.call(t, s = u[c++]) && e.push(s);
        return e;
      };
    }, function (t, e, n) {
      var r = n(1).document;
      t.exports = r && r.documentElement;
    }, function (t, e, n) {
      var r = n(60);
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == r(t) ? t.split("") : Object(t);
      };
    }, function (t, e, n) {
      var r = n(60);

      t.exports = Array.isArray || function (t) {
        return "Array" == r(t);
      };
    }, function (t, e, n) {

      var r = n(64),
          i = n(23),
          o = n(35),
          s = {};
      n(12)(s, n(14)("iterator"), function () {
        return this;
      }), t.exports = function (t, e, n) {
        t.prototype = r(s, {
          next: i(1, n)
        }), o(t, e + " Iterator");
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        return {
          value: e,
          done: !!t
        };
      };
    }, function (t, e, n) {
      var r = n(24)("meta"),
          i = n(18),
          o = n(6),
          s = n(7).f,
          u = 0,
          a = Object.isExtensible || function () {
        return !0;
      },
          c = !n(21)(function () {
        return a(Object.preventExtensions({}));
      }),
          l = function (t) {
        s(t, r, {
          value: {
            i: "O" + ++u,
            w: {}
          }
        });
      },
          f = function (t, e) {
        if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

        if (!o(t, r)) {
          if (!a(t)) return "F";
          if (!e) return "E";
          l(t);
        }

        return t[r].i;
      },
          p = function (t, e) {
        if (!o(t, r)) {
          if (!a(t)) return !0;
          if (!e) return !1;
          l(t);
        }

        return t[r].w;
      },
          h = function (t) {
        return c && d.NEED && a(t) && !o(t, r) && l(t), t;
      },
          d = t.exports = {
        KEY: r,
        NEED: !1,
        fastKey: f,
        getWeak: p,
        onFreeze: h
      };
    }, function (t, e, n) {
      var r = n(7),
          i = n(20),
          o = n(33);
      t.exports = n(5) ? Object.defineProperties : function (t, e) {
        i(t);

        for (var n, s = o(e), u = s.length, a = 0; u > a;) r.f(t, n = s[a++], e[n]);

        return t;
      };
    }, function (t, e, n) {
      var r = n(34),
          i = n(23),
          o = n(13),
          s = n(39),
          u = n(6),
          a = n(62),
          c = Object.getOwnPropertyDescriptor;
      e.f = n(5) ? c : function (t, e) {
        if (t = o(t), e = s(e, !0), a) try {
          return c(t, e);
        } catch (t) {}
        if (u(t, e)) return i(!r.f.call(t, e), t[e]);
      };
    }, function (t, e, n) {
      var r = n(13),
          i = n(65).f,
          o = {}.toString,
          s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
          u = function (t) {
        try {
          return i(t);
        } catch (t) {
          return s.slice();
        }
      };

      t.exports.f = function (t) {
        return s && "[object Window]" == o.call(t) ? u(t) : i(r(t));
      };
    }, function (t, e, n) {
      var r = n(6),
          i = n(69),
          o = n(36)("IE_PROTO"),
          s = Object.prototype;

      t.exports = Object.getPrototypeOf || function (t) {
        return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
      };
    }, function (t, e, n) {
      var r = n(38),
          i = n(29);

      t.exports = function (t) {
        return function (e, n) {
          var o,
              s,
              u = String(i(e)),
              a = r(n),
              c = u.length;
          return a < 0 || a >= c ? t ? "" : void 0 : (o = u.charCodeAt(a), o < 55296 || o > 56319 || a + 1 === c || (s = u.charCodeAt(a + 1)) < 56320 || s > 57343 ? t ? u.charAt(a) : o : t ? u.slice(a, a + 2) : s - 56320 + (o - 55296 << 10) + 65536);
        };
      };
    }, function (t, e, n) {
      var r = n(38),
          i = Math.max,
          o = Math.min;

      t.exports = function (t, e) {
        return t = r(t), t < 0 ? i(t + e, 0) : o(t, e);
      };
    }, function (t, e, n) {
      var r = n(38),
          i = Math.min;

      t.exports = function (t) {
        return t > 0 ? i(r(t), 9007199254740991) : 0;
      };
    }, function (t, e, n) {

      var r = n(97),
          i = n(105),
          o = n(32),
          s = n(13);
      t.exports = n(63)(Array, "Array", function (t, e) {
        this._t = s(t), this._i = 0, this._k = e;
      }, function () {
        var t = this._t,
            e = this._k,
            n = this._i++;
        return !t || n >= t.length ? (this._t = void 0, i(1)) : "keys" == e ? i(0, n) : "values" == e ? i(0, t[n]) : i(0, [n, t[n]]);
      }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
    }, function (t, e, n) {
      var r = n(31);
      r(r.S + r.F * !n(5), "Object", {
        defineProperty: n(7).f
      });
    }, function (t, e) {}, function (t, e, n) {

      var r = n(111)(!0);
      n(63)(String, "String", function (t) {
        this._t = String(t), this._i = 0;
      }, function () {
        var t,
            e = this._t,
            n = this._i;
        return n >= e.length ? {
          value: void 0,
          done: !0
        } : (t = r(e, n), this._i += t.length, {
          value: t,
          done: !1
        });
      });
    }, function (t, e, n) {

      var r = n(1),
          i = n(6),
          o = n(5),
          s = n(31),
          u = n(68),
          a = n(106).KEY,
          c = n(21),
          l = n(37),
          f = n(35),
          p = n(24),
          h = n(14),
          d = n(41),
          v = n(40),
          y = n(100),
          g = n(103),
          m = n(20),
          b = n(18),
          x = n(69),
          _ = n(13),
          O = n(39),
          S = n(23),
          w = n(64),
          k = n(109),
          L = n(108),
          E = n(66),
          P = n(7),
          T = n(33),
          V = L.f,
          j = P.f,
          C = k.f,
          D = r.Symbol,
          A = r.JSON,
          N = A && A.stringify,
          M = h("_hidden"),
          F = h("toPrimitive"),
          I = {}.propertyIsEnumerable,
          $ = l("symbol-registry"),
          R = l("symbols"),
          B = l("op-symbols"),
          G = Object.prototype,
          H = "function" == typeof D && !!E.f,
          U = r.QObject,
          K = !U || !U.prototype || !U.prototype.findChild,
          z = o && c(function () {
        return 7 != w(j({}, "a", {
          get: function () {
            return j(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (t, e, n) {
        var r = V(G, e);
        r && delete G[e], j(t, e, n), r && t !== G && j(G, e, r);
      } : j,
          W = function (t) {
        var e = R[t] = w(D.prototype);
        return e._k = t, e;
      },
          q = H && "symbol" == typeof D.iterator ? function (t) {
        return "symbol" == typeof t;
      } : function (t) {
        return t instanceof D;
      },
          J = function (t, e, n) {
        return t === G && J(B, e, n), m(t), e = O(e, !0), m(n), i(R, e) ? (n.enumerable ? (i(t, M) && t[M][e] && (t[M][e] = !1), n = w(n, {
          enumerable: S(0, !1)
        })) : (i(t, M) || j(t, M, S(1, {})), t[M][e] = !0), z(t, e, n)) : j(t, e, n);
      },
          X = function (t, e) {
        m(t);

        for (var n, r = y(e = _(e)), i = 0, o = r.length; o > i;) J(t, n = r[i++], e[n]);

        return t;
      },
          Y = function (t, e) {
        return void 0 === e ? w(t) : X(w(t), e);
      },
          Q = function (t) {
        var e = I.call(this, t = O(t, !0));
        return !(this === G && i(R, t) && !i(B, t)) && (!(e || !i(this, t) || !i(R, t) || i(this, M) && this[M][t]) || e);
      },
          Z = function (t, e) {
        if (t = _(t), e = O(e, !0), t !== G || !i(R, e) || i(B, e)) {
          var n = V(t, e);
          return !n || !i(R, e) || i(t, M) && t[M][e] || (n.enumerable = !0), n;
        }
      },
          tt = function (t) {
        for (var e, n = C(_(t)), r = [], o = 0; n.length > o;) i(R, e = n[o++]) || e == M || e == a || r.push(e);

        return r;
      },
          et = function (t) {
        for (var e, n = t === G, r = C(n ? B : _(t)), o = [], s = 0; r.length > s;) !i(R, e = r[s++]) || n && !i(G, e) || o.push(R[e]);

        return o;
      };

      H || (D = function () {
        if (this instanceof D) throw TypeError("Symbol is not a constructor!");

        var t = p(arguments.length > 0 ? arguments[0] : void 0),
            e = function (n) {
          this === G && e.call(B, n), i(this, M) && i(this[M], t) && (this[M][t] = !1), z(this, t, S(1, n));
        };

        return o && K && z(G, t, {
          configurable: !0,
          set: e
        }), W(t);
      }, u(D.prototype, "toString", function () {
        return this._k;
      }), L.f = Z, P.f = J, n(65).f = k.f = tt, n(34).f = Q, E.f = et, o && !n(22) && u(G, "propertyIsEnumerable", Q, !0), d.f = function (t) {
        return W(h(t));
      }), s(s.G + s.W + s.F * !H, {
        Symbol: D
      });

      for (var nt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), rt = 0; nt.length > rt;) h(nt[rt++]);

      for (var it = T(h.store), ot = 0; it.length > ot;) v(it[ot++]);

      s(s.S + s.F * !H, "Symbol", {
        for: function (t) {
          return i($, t += "") ? $[t] : $[t] = D(t);
        },
        keyFor: function (t) {
          if (!q(t)) throw TypeError(t + " is not a symbol!");

          for (var e in $) if ($[e] === t) return e;
        },
        useSetter: function () {
          K = !0;
        },
        useSimple: function () {
          K = !1;
        }
      }), s(s.S + s.F * !H, "Object", {
        create: Y,
        defineProperty: J,
        defineProperties: X,
        getOwnPropertyDescriptor: Z,
        getOwnPropertyNames: tt,
        getOwnPropertySymbols: et
      });
      var st = c(function () {
        E.f(1);
      });
      s(s.S + s.F * st, "Object", {
        getOwnPropertySymbols: function (t) {
          return E.f(x(t));
        }
      }), A && s(s.S + s.F * (!H || c(function () {
        var t = D();
        return "[null]" != N([t]) || "{}" != N({
          a: t
        }) || "{}" != N(Object(t));
      })), "JSON", {
        stringify: function (t) {
          for (var e, n, r = [t], i = 1; arguments.length > i;) r.push(arguments[i++]);

          if (n = e = r[1], (b(e) || void 0 !== t) && !q(t)) return g(e) || (e = function (t, e) {
            if ("function" == typeof n && (e = n.call(this, t, e)), !q(e)) return e;
          }), r[1] = e, N.apply(A, r);
        }
      }), D.prototype[F] || n(12)(D.prototype, F, D.prototype.valueOf), f(D, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
    }, function (t, e, n) {
      n(40)("asyncIterator");
    }, function (t, e, n) {
      n(40)("observable");
    }, function (t, e, n) {
      n(114);

      for (var r = n(1), i = n(12), o = n(32), s = n(14)("toStringTag"), u = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), a = 0; a < u.length; a++) {
        var c = u[a],
            l = r[c],
            f = l && l.prototype;
        f && !f[s] && i(f, s, c), o[c] = o.Array;
      }
    }, function (t, e, n) {
      var r = n(70),
          i = n(53),
          o = n(47),
          s = n(52);

      t.exports = function (t, e, n, u, a) {
        r(e);
        var c = i(t),
            l = o(c),
            f = s(c.length),
            p = a ? f - 1 : 0,
            h = a ? -1 : 1;
        if (n < 2) for (;;) {
          if (p in l) {
            u = l[p], p += h;
            break;
          }

          if (p += h, a ? p < 0 : f <= p) throw TypeError("Reduce of empty array with no initial value");
        }

        for (; a ? p >= 0 : f > p; p += h) p in l && (u = e(u, l[p], p, c));

        return u;
      };
    }, function (t, e, n) {
      var r = n(16),
          i = n(75),
          o = n(4)("species");

      t.exports = function (t) {
        var e;
        return i(t) && (e = t.constructor, "function" != typeof e || e !== Array && !i(e.prototype) || (e = void 0), r(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
      };
    }, function (t, e, n) {
      var r = n(123);

      t.exports = function (t, e) {
        return new (r(t))(e);
      };
    }, function (t, e, n) {
      var r = n(25),
          i = n(4)("toStringTag"),
          o = "Arguments" == r(function () {
        return arguments;
      }()),
          s = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      };

      t.exports = function (t) {
        var e, n, u;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = s(e = Object(t), i)) ? n : o ? r(e) : "Object" == (u = r(e)) && "function" == typeof e.callee ? "Arguments" : u;
      };
    }, function (t, e, n) {

      n(149);

      var r = n(11),
          i = n(10),
          o = n(9),
          s = n(26),
          u = n(4),
          a = n(81),
          c = u("species"),
          l = !o(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }),
          f = function () {
        var t = /(?:)/,
            e = t.exec;

        t.exec = function () {
          return e.apply(this, arguments);
        };

        var n = "ab".split(t);
        return 2 === n.length && "a" === n[0] && "b" === n[1];
      }();

      t.exports = function (t, e, n) {
        var p = u(t),
            h = !o(function () {
          var e = {};
          return e[p] = function () {
            return 7;
          }, 7 != ""[t](e);
        }),
            d = h ? !o(function () {
          var e = !1,
              n = /a/;
          return n.exec = function () {
            return e = !0, null;
          }, "split" === t && (n.constructor = {}, n.constructor[c] = function () {
            return n;
          }), n[p](""), !e;
        }) : void 0;

        if (!h || !d || "replace" === t && !l || "split" === t && !f) {
          var v = /./[p],
              y = n(s, p, ""[t], function (t, e, n, r, i) {
            return e.exec === a ? h && !i ? {
              done: !0,
              value: v.call(e, n, r)
            } : {
              done: !0,
              value: t.call(n, e, r)
            } : {
              done: !1
            };
          }),
              g = y[0],
              m = y[1];
          r(String.prototype, t, g), i(RegExp.prototype, p, 2 == e ? function (t, e) {
            return m.call(t, this, e);
          } : function (t) {
            return m.call(t, this);
          });
        }
      };
    }, function (t, e, n) {
      t.exports = n(51)("native-function-to-string", Function.toString);
    }, function (t, e, n) {
      var r = n(3).document;
      t.exports = r && r.documentElement;
    }, function (t, e, n) {
      var r = n(16),
          i = n(139).set;

      t.exports = function (t, e, n) {
        var o,
            s = e.constructor;
        return s !== n && "function" == typeof s && (o = s.prototype) !== n.prototype && r(o) && i && i(t, o), t;
      };
    }, function (t, e, n) {

      var r = n(77),
          i = n(49),
          o = n(82),
          s = {};
      n(10)(s, n(4)("iterator"), function () {
        return this;
      }), t.exports = function (t, e, n) {
        t.prototype = r(s, {
          next: i(1, n)
        }), o(t, e + " Iterator");
      };
    }, function (t, e, n) {

      var r = n(76),
          i = n(0),
          o = n(11),
          s = n(10),
          u = n(48),
          a = n(130),
          c = n(82),
          l = n(135),
          f = n(4)("iterator"),
          p = !([].keys && "next" in [].keys()),
          h = function () {
        return this;
      };

      t.exports = function (t, e, n, d, v, y, g) {
        a(n, e, d);

        var m,
            b,
            x,
            _ = function (t) {
          if (!p && t in k) return k[t];

          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new n(this, t);
              };
          }

          return function () {
            return new n(this, t);
          };
        },
            O = e + " Iterator",
            S = "values" == v,
            w = !1,
            k = t.prototype,
            L = k[f] || k["@@iterator"] || v && k[v],
            E = L || _(v),
            P = v ? S ? _("entries") : E : void 0,
            T = "Array" == e ? k.entries || L : L;

        if (T && (x = l(T.call(new t()))) !== Object.prototype && x.next && (c(x, O, !0), r || "function" == typeof x[f] || s(x, f, h)), S && L && "values" !== L.name && (w = !0, E = function () {
          return L.call(this);
        }), r && !g || !p && !w && k[f] || s(k, f, E), u[e] = E, u[O] = h, v) if (m = {
          values: S ? E : _("values"),
          keys: y ? E : _("keys"),
          entries: P
        }, g) for (b in m) b in k || o(k, b, m[b]);else i(i.P + i.F * (p || w), e, m);
        return m;
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        return {
          value: e,
          done: !!t
        };
      };
    }, function (t, e, n) {
      var r = n(19),
          i = n(8),
          o = n(80);
      t.exports = n(2) ? Object.defineProperties : function (t, e) {
        i(t);

        for (var n, s = o(e), u = s.length, a = 0; u > a;) r.f(t, n = s[a++], e[n]);

        return t;
      };
    }, function (t, e, n) {
      var r = n(79),
          i = n(45).concat("length", "prototype");

      e.f = Object.getOwnPropertyNames || function (t) {
        return r(t, i);
      };
    }, function (t, e, n) {
      var r = n(15),
          i = n(53),
          o = n(50)("IE_PROTO"),
          s = Object.prototype;

      t.exports = Object.getPrototypeOf || function (t) {
        return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
      };
    }, function (t, e) {
      e.f = {}.propertyIsEnumerable;
    }, function (t, e, n) {

      var r = n(125),
          i = RegExp.prototype.exec;

      t.exports = function (t, e) {
        var n = t.exec;

        if ("function" == typeof n) {
          var o = n.call(t, e);
          if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");
          return o;
        }

        if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return i.call(t, e);
      };
    }, function (t, e) {
      t.exports = Object.is || function (t, e) {
        return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
      };
    }, function (t, e, n) {
      var r = n(16),
          i = n(8),
          o = function (t, e) {
        if (i(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };

      t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
          try {
            r = n(44)(Function.call, n(78).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
          } catch (t) {
            e = !0;
          }

          return function (t, n) {
            return o(t, n), e ? t.__proto__ = n : r(t, n), t;
          };
        }({}, !1) : void 0),
        check: o
      };
    }, function (t, e) {
      t.exports = "\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";
    }, function (t, e, n) {
      var r = n(84),
          i = Math.max,
          o = Math.min;

      t.exports = function (t, e) {
        return t = r(t), t < 0 ? i(t + e, 0) : o(t, e);
      };
    }, function (t, e, n) {

      var r = n(0),
          i = n(42)(2);
      r(r.P + r.F * !n(27)([].filter, !0), "Array", {
        filter: function (t) {
          return i(this, t, arguments[1]);
        }
      });
    }, function (t, e, n) {

      var r = n(0),
          i = n(72)(!1),
          o = [].indexOf,
          s = !!o && 1 / [1].indexOf(1, -0) < 0;
      r(r.P + r.F * (s || !n(27)(o)), "Array", {
        indexOf: function (t) {
          return s ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
        }
      });
    }, function (t, e, n) {
      var r = n(0);
      r(r.S, "Array", {
        isArray: n(75)
      });
    }, function (t, e, n) {

      var r = n(71),
          i = n(132),
          o = n(48),
          s = n(28);
      t.exports = n(131)(Array, "Array", function (t, e) {
        this._t = s(t), this._i = 0, this._k = e;
      }, function () {
        var t = this._t,
            e = this._k,
            n = this._i++;
        return !t || n >= t.length ? (this._t = void 0, i(1)) : "keys" == e ? i(0, n) : "values" == e ? i(0, t[n]) : i(0, [n, t[n]]);
      }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
    }, function (t, e, n) {

      var r = n(0),
          i = n(42)(1);
      r(r.P + r.F * !n(27)([].map, !0), "Array", {
        map: function (t) {
          return i(this, t, arguments[1]);
        }
      });
    }, function (t, e, n) {

      var r = n(0),
          i = n(122);
      r(r.P + r.F * !n(27)([].reduce, !0), "Array", {
        reduce: function (t) {
          return i(this, t, arguments.length, arguments[1], !1);
        }
      });
    }, function (t, e, n) {
      var r = Date.prototype,
          i = r.toString,
          o = r.getTime;
      new Date(NaN) + "" != "Invalid Date" && n(11)(r, "toString", function () {
        var t = o.call(this);
        return t === t ? i.call(this) : "Invalid Date";
      });
    }, function (t, e, n) {

      var r = n(81);
      n(0)({
        target: "RegExp",
        proto: !0,
        forced: r !== /./.exec
      }, {
        exec: r
      });
    }, function (t, e, n) {
      n(2) && "g" != /./g.flags && n(19).f(RegExp.prototype, "flags", {
        configurable: !0,
        get: n(46)
      });
    }, function (t, e, n) {

      var r = n(8),
          i = n(138),
          o = n(137);
      n(126)("search", 1, function (t, e, n, s) {
        return [function (n) {
          var r = t(this),
              i = void 0 == n ? void 0 : n[e];
          return void 0 !== i ? i.call(n, r) : new RegExp(n)[e](String(r));
        }, function (t) {
          var e = s(n, t, this);
          if (e.done) return e.value;
          var u = r(t),
              a = String(this),
              c = u.lastIndex;
          i(c, 0) || (u.lastIndex = 0);
          var l = o(u, a);
          return i(u.lastIndex, c) || (u.lastIndex = c), null === l ? -1 : l.index;
        }];
      });
    }, function (t, e, n) {

      n(150);

      var r = n(8),
          i = n(46),
          o = n(2),
          s = /./.toString,
          u = function (t) {
        n(11)(RegExp.prototype, "toString", t, !0);
      };

      n(9)(function () {
        return "/a/b" != s.call({
          source: "a",
          flags: "b"
        });
      }) ? u(function () {
        var t = r(this);
        return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
      }) : "toString" != s.name && u(function () {
        return s.call(this);
      });
    }, function (t, e, n) {

      n(83)("trim", function (t) {
        return function () {
          return t(this, 3);
        };
      });
    }, function (t, e, n) {
      for (var r = n(145), i = n(80), o = n(11), s = n(3), u = n(10), a = n(48), c = n(4), l = c("iterator"), f = c("toStringTag"), p = a.Array, h = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1
      }, d = i(h), v = 0; v < d.length; v++) {
        var y,
            g = d[v],
            m = h[g],
            b = s[g],
            x = b && b.prototype;
        if (x && (x[l] || u(x, l, p), x[f] || u(x, f, g), a[g] = p, m)) for (y in r) x[y] || o(x, y, r[y], !0);
      }
    }, function (t, e) {}, function (t, e) {
      t.exports = function (t, e, n, r, i, o) {
        var s,
            u = t = t || {},
            a = typeof t.default;
        "object" !== a && "function" !== a || (s = t, u = t.default);
        var c = "function" == typeof u ? u.options : u;
        e && (c.render = e.render, c.staticRenderFns = e.staticRenderFns, c._compiled = !0), n && (c.functional = !0), i && (c._scopeId = i);
        var l;

        if (o ? (l = function (t) {
          t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), r && r.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
        }, c._ssrRegister = l) : r && (l = r), l) {
          var f = c.functional,
              p = f ? c.render : c.beforeCreate;
          f ? (c._injectStyles = l, c.render = function (t, e) {
            return l.call(e), p(t, e);
          }) : c.beforeCreate = p ? [].concat(p, l) : [l];
        }

        return {
          esModule: s,
          exports: u,
          options: c
        };
      };
    }, function (t, e, n) {

      var r = function () {
        var t = this,
            e = t.$createElement,
            n = t._self._c || e;
        return n("div", {
          staticClass: "multiselect",
          class: {
            "multiselect--active": t.isOpen,
            "multiselect--disabled": t.disabled,
            "multiselect--above": t.isAbove
          },
          attrs: {
            tabindex: t.searchable ? -1 : t.tabindex
          },
          on: {
            focus: function (e) {
              return t.activate();
            },
            blur: function (e) {
              !t.searchable && t.deactivate();
            },
            keydown: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? null : e.target !== e.currentTarget ? null : (e.preventDefault(), t.pointerForward());
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? null : e.target !== e.currentTarget ? null : (e.preventDefault(), t.pointerBackward());
            }],
            keypress: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") && t._k(e.keyCode, "tab", 9, e.key, "Tab") ? null : (e.stopPropagation(), e.target !== e.currentTarget ? null : t.addPointerElement(e));
            },
            keyup: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"]) ? null : t.deactivate();
            }
          }
        }, [t._t("caret", [n("div", {
          staticClass: "multiselect__select",
          on: {
            mousedown: function (e) {
              return e.preventDefault(), e.stopPropagation(), t.toggle();
            }
          }
        })], {
          toggle: t.toggle
        }), t._v(" "), t._t("clear", null, {
          search: t.search
        }), t._v(" "), n("div", {
          ref: "tags",
          staticClass: "multiselect__tags"
        }, [t._t("selection", [n("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.visibleValues.length > 0,
            expression: "visibleValues.length > 0"
          }],
          staticClass: "multiselect__tags-wrap"
        }, [t._l(t.visibleValues, function (e, r) {
          return [t._t("tag", [n("span", {
            key: r,
            staticClass: "multiselect__tag"
          }, [n("span", {
            domProps: {
              textContent: t._s(t.getOptionLabel(e))
            }
          }), t._v(" "), n("i", {
            staticClass: "multiselect__tag-icon",
            attrs: {
              "aria-hidden": "true",
              tabindex: "1"
            },
            on: {
              keypress: function (n) {
                return !n.type.indexOf("key") && t._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : (n.preventDefault(), t.removeElement(e));
              },
              mousedown: function (n) {
                return n.preventDefault(), t.removeElement(e);
              }
            }
          })])], {
            option: e,
            search: t.search,
            remove: t.removeElement
          })];
        })], 2), t._v(" "), t.internalValue && t.internalValue.length > t.limit ? [t._t("limit", [n("strong", {
          staticClass: "multiselect__strong",
          domProps: {
            textContent: t._s(t.limitText(t.internalValue.length - t.limit))
          }
        })])] : t._e()], {
          search: t.search,
          remove: t.removeElement,
          values: t.visibleValues,
          isOpen: t.isOpen
        }), t._v(" "), n("transition", {
          attrs: {
            name: "multiselect__loading"
          }
        }, [t._t("loading", [n("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.loading,
            expression: "loading"
          }],
          staticClass: "multiselect__spinner"
        })])], 2), t._v(" "), t.searchable && !t.searchInDropdown ? n("input", {
          ref: "search",
          staticClass: "multiselect__input",
          style: t.inputStyle,
          attrs: {
            name: t.name,
            id: t.id,
            type: "text",
            autocomplete: "nope",
            placeholder: t.placeholder,
            disabled: t.disabled,
            tabindex: t.tabindex
          },
          domProps: {
            value: t.search
          },
          on: {
            input: function (e) {
              return t.updateSearch(e.target.value);
            },
            focus: function (e) {
              return e.preventDefault(), t.activate();
            },
            blur: function (e) {
              return e.preventDefault(), t.deactivate();
            },
            keyup: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"]) ? null : t.deactivate();
            },
            keydown: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? null : (e.preventDefault(), t.pointerForward());
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? null : (e.preventDefault(), t.pointerBackward());
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "delete", [8, 46], e.key, ["Backspace", "Delete", "Del"]) ? null : (e.stopPropagation(), t.removeLastElement());
            }],
            keypress: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : (e.preventDefault(), e.stopPropagation(), e.target !== e.currentTarget ? null : t.addPointerElement(e));
            }
          }
        }) : t._e(), t._v(" "), t.isSingleLabelVisible ? n("span", {
          staticClass: "multiselect__single",
          on: {
            mousedown: function (e) {
              return e.preventDefault(), t.toggle(e);
            }
          }
        }, [t._t("singleLabel", [[t._v(t._s(t.currentOptionLabel))]], {
          option: t.singleValue
        })], 2) : t._e(), t._v(" "), t.isPlaceholderVisible ? n("span", {
          staticClass: "multiselect__placeholder",
          on: {
            mousedown: function (e) {
              return e.preventDefault(), t.toggle(e);
            }
          }
        }, [t._t("placeholder", [t._v("\n          " + t._s(t.placeholder) + "\n        ")])], 2) : t._e()], 2), t._v(" "), n("transition", {
          attrs: {
            name: "multiselect"
          }
        }, [n("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.isOpen,
            expression: "isOpen"
          }],
          ref: "list",
          staticClass: "multiselect__content-wrapper",
          style: {
            maxHeight: t.optimizedHeight + "px"
          },
          attrs: {
            tabindex: "-1"
          },
          on: {
            focus: t.activate,
            mousedown: function (t) {
              t.preventDefault();
            }
          }
        }, [n("ul", {
          staticClass: "multiselect__content",
          style: t.contentStyle
        }, [t.searchable && t.searchInDropdown ? n("div", {
          staticClass: "input-wrapper"
        }, [t.searchable ? n("input", {
          ref: "search",
          staticClass: "multiselect__input",
          style: t.inputStyle,
          attrs: {
            name: t.name,
            id: t.id,
            type: "text",
            autocomplete: "nope",
            placeholder: t.placeholder,
            disabled: t.disabled,
            tabindex: t.tabindex
          },
          domProps: {
            value: t.search
          },
          on: {
            input: function (e) {
              return t.updateSearch(e.target.value);
            },
            focus: function (e) {
              return e.preventDefault(), t.activate();
            },
            blur: function (e) {
              return e.preventDefault(), t.deactivate();
            },
            keyup: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"]) ? null : t.deactivate();
            },
            keydown: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? null : (e.preventDefault(), t.pointerForward());
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? null : (e.preventDefault(), t.pointerBackward());
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "delete", [8, 46], e.key, ["Backspace", "Delete", "Del"]) ? null : (e.stopPropagation(), t.removeLastElement());
            }],
            keypress: function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : (e.preventDefault(), e.stopPropagation(), e.target !== e.currentTarget ? null : t.addPointerElement(e));
            }
          }
        }) : t._e()]) : t._e(), t._v(" "), t._t("beforeList"), t._v(" "), t.multiple && t.max === t.internalValue.length ? n("li", [n("span", {
          staticClass: "multiselect__option"
        }, [t._t("maxElements", [t._v("Maximum of " + t._s(t.max) + " options selected. First remove a selected option to select another.")])], 2)]) : t._e(), t._v(" "), !t.max || t.internalValue.length < t.max ? t._l(t.filteredOptions, function (e, r) {
          return n("li", {
            key: r,
            staticClass: "multiselect__element"
          }, [e && (e.$isLabel || e.$isDisabled) ? t._e() : n("span", {
            staticClass: "multiselect__option",
            class: t.optionHighlight(r, e),
            attrs: {
              "data-select": e && e.isTag ? t.tagPlaceholder : t.selectLabelText,
              "data-selected": t.selectedLabelText,
              "data-deselect": t.deselectLabelText
            },
            on: {
              click: function (n) {
                return n.stopPropagation(), t.select(e);
              },
              mouseenter: function (e) {
                return e.target !== e.currentTarget ? null : t.pointerSet(r);
              }
            }
          }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], {
            option: e,
            search: t.search
          })], 2), t._v(" "), e && (e.$isLabel || e.$isDisabled) ? n("span", {
            staticClass: "multiselect__option",
            class: t.groupHighlight(r, e),
            attrs: {
              "data-select": t.groupSelect && t.selectGroupLabelText,
              "data-deselect": t.groupSelect && t.deselectGroupLabelText
            },
            on: {
              mouseenter: function (e) {
                if (e.target !== e.currentTarget) return null;
                t.groupSelect && t.pointerSet(r);
              },
              mousedown: function (n) {
                return n.preventDefault(), t.selectGroup(e);
              }
            }
          }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], {
            option: e,
            search: t.search
          })], 2) : t._e()]);
        }) : t._e(), t._v(" "), n("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.showNoResults && 0 === t.filteredOptions.length && t.search && !t.loading,
            expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
          }]
        }, [n("span", {
          staticClass: "multiselect__option"
        }, [t._t("noResult", [t._v("No elements found. Consider changing the search query.")], {
          search: t.search
        })], 2)]), t._v(" "), n("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.showNoOptions && 0 === t.options.length && !t.search && !t.loading,
            expression: "showNoOptions && (options.length === 0 && !search && !loading)"
          }]
        }, [n("span", {
          staticClass: "multiselect__option"
        }, [t._t("noOptions", [t._v("List is empty.")])], 2)]), t._v(" "), t._t("afterList")], 2)])])], 2);
      },
          i = [],
          o = {
        render: r,
        staticRenderFns: i
      };

      e.a = o;
    }]);
  });
});
var VueMultiselect = unwrapExports(vueMultiselect_min);
var vueMultiselect_min_1 = vueMultiselect_min.VueMultiselect;

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

var lodash_isobject = isObject;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect__content .input-wrapper{position:sticky;top:0;background-color:inherit;z-index:10;border-radius:none;background:#fff}.multiselect__content .multiselect__input{position:relative;padding:8px 8px 8px 16px;margin:0;background:transparent}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}";
styleInject(css_248z);

var lodash_clonedeep = createCommonjsModule(function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to match `RegExp` flags from their coerced string values. */

  var reFlags = /\w*$/;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values supported by `_.clone`. */

  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports =  exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */

  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }
  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */


  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }
  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */


  function arrayEach(array, iteratee) {
    var index = -1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }

    return array;
  }
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */


  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */


  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array ? array.length : 0;

    if (initAccum && length) {
      accumulator = array[++index];
    }

    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }

    return accumulator;
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */


  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;

    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }

    return result;
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /** Used to resolve the decompiled source of functions. */


  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    this.__data__ = new ListCache(entries);
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    return this.__data__['delete'](key);
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var cache = this.__data__;

    if (cache instanceof ListCache) {
      var pairs = cache.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        return this;
      }

      cache = this.__data__ = new MapCache(pairs);
    }

    cache.set(key, value);
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length,
        skipIndexes = !!length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      object[key] = value;
    }
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */


  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @param {boolean} [isFull] Specify a clone including symbols.
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */


  function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;

    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }

    if (result !== undefined) {
      return result;
    }

    if (!isObject(value)) {
      return value;
    }

    var isArr = isArray(value);

    if (isArr) {
      result = initCloneArray(value);

      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;

      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }

      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        if (isHostObject(value)) {
          return object ? value : {};
        }

        result = initCloneObject(isFunc ? {} : value);

        if (!isDeep) {
          return copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }

        result = initCloneByTag(value, tag, baseClone, isDeep);
      }
    } // Check for circular references and return its corresponding clone.


    stack || (stack = new Stack());
    var stacked = stack.get(value);

    if (stacked) {
      return stacked;
    }

    stack.set(value, result);

    if (!isArr) {
      var props = isFull ? getAllKeys(value) : keys(value);
    }

    arrayEach(props || value, function (subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      } // Recursively populate clone (susceptible to call stack limits).


      assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
  }
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */


  function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * The base implementation of `getTag`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    return objectToString.call(value);
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */


  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
  }
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */


  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */


  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  /**
   * Creates a clone of `map`.
   *
   * @private
   * @param {Object} map The map to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned map.
   */


  function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor());
  }
  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */


  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  /**
   * Creates a clone of `set`.
   *
   * @private
   * @param {Object} set The set to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned set.
   */


  function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor());
  }
  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */


  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */


  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */


  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }

    return object;
  }
  /**
   * Copies own symbol properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */


  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * Creates an array of the own enumerable symbol properties of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */


  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
  // for data views in Edge < 14, and promises in Node.js.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function (value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : undefined;

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */


  function initCloneArray(array) {
    var length = array.length,
        result = array.constructor(length); // Add properties assigned by `RegExp#exec`.

    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }

    return result;
  }
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {Function} cloneFunc The function to clone values.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;

    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);

      case boolTag:
      case dateTag:
        return new Ctor(+object);

      case dataViewTag:
        return cloneDataView(object, isDeep);

      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);

      case mapTag:
        return cloneMap(object, isDeep, cloneFunc);

      case numberTag:
      case stringTag:
        return new Ctor(object);

      case regexpTag:
        return cloneRegExp(object);

      case setTag:
        return cloneSet(object, isDeep, cloneFunc);

      case symbolTag:
        return cloneSymbol(object);
    }
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * This method is like `_.clone` except that it recursively clones `value`.
   *
   * @static
   * @memberOf _
   * @since 1.0.0
   * @category Lang
   * @param {*} value The value to recursively clone.
   * @returns {*} Returns the deep cloned value.
   * @see _.clone
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var deep = _.cloneDeep(objects);
   * console.log(deep[0] === objects[0]);
   * // => false
   */


  function cloneDeep(value) {
    return baseClone(value, true, true);
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = cloneDeep;
});

var dist = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function isIE() {
      var _isIE = false;

      if (typeof navigator !== "undefined") {
        _isIE = navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/Edge/);
      }

      return _isIE;
    }

    var lastTime = 0;
    var vendors = ["ms", "moz", "webkit", "o"];

    if (typeof window === 'undefined') {
      commonjsGlobal.window = {};
    }

    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
      window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
    }

    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
    }

    if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
    }

    var $requestAnimationFrame = window.requestAnimationFrame;
    var $cancelAnimationFrame = window.cancelAnimationFrame;

    function resizeHandler(event) {
      event.__currentTarget__ = this.__container__;

      this.__resize__handler__.call(this, {
        width: this.offsetWidth,
        height: this.offsetHeight
      }, event);
    }

    function resizeTriggerListener(event) {
      var _resizeTrigger = event.currentTarget || event.srcElement;

      if (_resizeTrigger.__requestAnimationFrameID__) {
        $cancelAnimationFrame(_resizeTrigger.__requestAnimationFrameID__);
      }

      _resizeTrigger.__requestAnimationFrameID__ = $requestAnimationFrame(resizeHandler.bind(this, event));
    }

    function registereResizeHandler() {
      if (document.attachEvent) {
        this.__container__.attachEvent("onresize", resizeHandler.bind(this));
      } else {
        this.contentDocument.defaultView.addEventListener("resize", resizeTriggerListener.bind(this));
      }
    }

    function createResizeTrigger() {
      var object = document.createElement("object");
      object.setAttribute("aria-hidden", "true");
      object.setAttribute("tabindex", -1);
      var objectStyle = "\n    display: block !important; \n    position: absolute !important; \n    top: 0 !important; \n    left: 0 !important; \n    width: 100% !important; \n    height: 100% !important; \n    overflow: hidden !important; \n    pointer-events: none !important; \n    z-index: -1 !important; \n    opacity: 0 !important;\n  ";
      object.setAttribute("style", objectStyle);
      object.type = "text/html";
      return object;
    }

    var resizeObserverDirective = {
      bind: function bind(el, binding, vnode, oldVnode) {
        el.__resizeTrigger__ = createResizeTrigger();
        el.__resizeTrigger__.__container__ = el;
        el.__resizeTrigger__.__resize__handler__ = binding.value;
        el.__resizeTrigger__.onload = registereResizeHandler;

        var _isIE = isIE();

        _isIE && el.appendChild(el.__resizeTrigger__);
        el.__resizeTrigger__.data = "about:blank";
        !_isIE && el.appendChild(el.__resizeTrigger__);
      },
      inserted: function inserted(el) {
        if (getComputedStyle(el).position === "static") {
          el.style.setProperty("position", "relative", "important");
        }
      },
      unbind: function unbind(el) {
        if (document.attachEvent) {
          el.detachEvent("onresize", resizeHandler);
        } else if (el.__resizeTrigger__ && el.__resizeTrigger__.contentDocument) {
          el.__resizeTrigger__.contentDocument.defaultView.removeEventListener("resize", resizeTriggerListener);

          el.__resizeTrigger__ = !el.removeChild(el.__resizeTrigger__);
        }
      }
    };
    var vueResizeObserver = {
      install: function install(Vue) {
        Vue.directive("resize", resizeObserverDirective);
      }
    };

    {
      module.exports = vueResizeObserver;
    }

    return vueResizeObserver;
  });
});

//
Vue.use(dist);

const formatOptions = options => {
  return options.forEach(option => {
    if (lodash_isobject(option) && "disabled" in option) {
      option["$isDisabled"] = option["disabled"];
      delete option["disabled"];
    }
  });
};

const isEqual = (a, b) => {
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;

  if (typeof a === "object") {
    // Prevent circular reference:
    if (a === b) return true;

    for (let key in a) {
      if (!Object.prototype.hasOwnProperty.call(a, key)) continue;
      if (typeof a[key] !== typeof b[key]) return false;

      if (typeof a[key] === "object") {
        if (!isEqual(a[key], b[key])) return false;
      } else if (a[key] !== b[key]) {
        return false;
      }
    } // Check that every key from b also exists in a:


    for (let key in b) {
      if (typeof b[key] !== typeof a[key]) return false;
    }

    return true;
  }

  return a === b;
}; // Copied from node_modules/vue-multiselect/src/multiselectMixin.js:

function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  return !opt;
}

const UNLIMITED = 99999;
var script = {
  name: "ZenMultiselect",
  components: {
    VueMultiselect
  },
  props: {
    allowEmpty: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    renderSelectElement: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Object, String, Array, Number],
      default: null
    },
    valid: {
      type: Boolean,
      default: null
    },
    showCheckboxes: {
      type: Boolean,
      default: true
    },
    customLabel: {
      type: Function,
      default: (option, label) => isEmpty(option) ? "" : label ? option[label] : option
    },
    label: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: UNLIMITED
    },
    customOptionSlot: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      myLimit: UNLIMITED,
      myOptions: [],
      calculatingLimit: false
    };
  },
  computed: {
    validationClass() {
      if (this.valid === null) {
        return "";
      }

      return this.valid ? "is-valid" : "is-invalid";
    },

    valueArray() {
      return Array.isArray(this.value) ? this.value : this.value && Object.keys(this.value).length ? [this.value] : [];
    },

    isValueSet() {
      return !!this.valueArray.length;
    },

    checkboxesVisible() {
      return !this.customOptionSlot && this.multiple && this.showCheckboxes;
    }

  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler: function (value) {
        formatOptions(value);
        this.myOptions = lodash_clonedeep(value);
        this.orderOptions();
        this.calcLimit();
      }
    }
  },
  created: function () {
    formatOptions(this.options);
  },
  methods: {
    clearSelectedValue() {
      const emptyValue = this.multiple ? [] : null;
      this.$emit("input", emptyValue);
    },

    async calcLimit() {
      if (!this.multiple) return;
      this.calculatingLimit = true;
      this.myLimit = UNLIMITED;
      await this.$nextTick();
      const items = this.$el.querySelectorAll(".multiselect__tags .multiselect__tag");
      const width = this.$el.offsetWidth - 140;
      let x = 0;
      let i = 0;

      while (items[i]) {
        x += items[i].offsetWidth;
        if (x > width) break;
        i++;
      }

      this.calculatingLimit = false;
      this.myLimit = Math.max(i, 1);
    },

    onChange() {
      this.calcLimit();
    },

    onOpen() {
      if (!this.multiple) return;
      this.myOptions = lodash_clonedeep(this.options);
      this.orderOptions();
      this.$nextTick(() => {
        let el = this.$el.querySelectorAll(".multiselect__content-wrapper")[0];
        el.scroll(0, 0);
      });
    },

    onClose() {
      this.calcLimit();
    },

    onResize(value) {
      if (!value.width || value.width === this.lastWidth) return;
      this.lastWidth = value.width;
      this.debounceCalcLimit();
    },

    debounceCalcLimit(time = 300) {
      clearTimeout(this.calcLimitTimer);
      this.calcLimitTimer = setTimeout(this.calcLimit, time);
    },

    isSelected(option) {
      for (let b of this.value || []) {
        if (isEqual(b, option)) {
          return true;
        }
      }
    },

    orderOptions() {
      if (!Array.isArray(this.value)) return; // Reorder items, so that selected are on top:

      let selected = this.myOptions.filter(a => this.isSelected(a, this.value));
      let unSelected = this.myOptions.filter(a => !this.isSelected(a, this.value));
      this.myOptions = selected.concat(unSelected);
    },

    // Copied from node_modules/vue-multiselect/src/multiselectMixin.js:
    getOptionLabel(option) {
      if (isEmpty(option)) return "";
      /* istanbul ignore else */

      if (option.isTag) return option.label;
      /* istanbul ignore else */

      if (option.$isLabel) return option.$groupLabel;
      let label = this.customLabel(option, this.label);
      /* istanbul ignore else */

      if (isEmpty(label)) return "";
      return label;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    staticClass: "multiselect-wrapper",
    class: {
      "calculating-limit": _vm.calculatingLimit,
      multiple: _vm.multiple
    }
  }, [_c("vue-multiselect", _vm._g(_vm._b({
    class: _vm.validationClass,
    attrs: {
      name: _vm.name,
      multiple: _vm.multiple,
      "search-in-dropdown": _vm.multiple,
      disabled: _vm.disabled,
      options: _vm.myOptions,
      "option-height": 35,
      value: _vm.value,
      "allow-empty": _vm.allowEmpty,
      "show-labels": false,
      label: _vm.label,
      "custom-label": _vm.customLabel,
      limit: _vm.myLimit
    },
    on: {
      input: _vm.onChange,
      open: _vm.onOpen,
      close: _vm.onClose
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (slot, slotName) {
      return {
        key: slotName,
        fn: function (props) {
          return [_vm._t(slotName, null, null, props)];
        }
      };
    }), {
      key: _vm.checkboxesVisible ? "option" : "",
      fn: function (props) {
        return _vm.checkboxesVisible ? [_c("div", {
          staticClass: "checkbox_parent"
        }, [_c("input", {
          staticClass: "multiselect__checkbox",
          attrs: {
            type: "checkbox"
          },
          domProps: {
            checked: _vm.isSelected(props.option)
          }
        }), _vm._v(" "), _c("span", [_vm._v("\n          " + _vm._s(_vm.getOptionLabel(props.option)) + "\n        ")])])] : undefined;
      }
    }, {
      key: "clear",
      fn: function () {
        return [_vm.renderSelectElement ? _c("select", {
          staticClass: "d-none",
          attrs: {
            multiple: _vm.multiple,
            name: _vm.name
          }
        }, _vm._l(_vm.valueArray, function (option) {
          return _c("option", {
            key: option ? option.value : null,
            attrs: {
              selected: ""
            },
            domProps: {
              value: option ? option.value : null
            }
          }, [_vm._v(_vm._s(option ? option.label : null))]);
        }), 0) : _vm._e(), _vm._v(" "), _c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.isValueSet && _vm.allowEmpty && !_vm.disabled,
            expression: "isValueSet && allowEmpty && !disabled"
          }],
          staticClass: "multiselect__clear-button",
          on: {
            mousedown: function ($event) {
              $event.preventDefault();
              return _vm.clearSelectedValue($event);
            }
          }
        }, [_vm._v("\n        ×\n      ")]), _vm._v(" "), _vm._t("clear")];
      },
      proxy: true
    }], null, true)
  }, "vue-multiselect", _vm.$attrs, false), _vm.$listeners), [_vm._v(" "), _vm.multiple ? _c("template", {
    slot: "limit"
  }, [_c("span", {
    staticClass: "multiselect__tag multiselect__limit-pill"
  }, [_c("span", [_vm._v("+" + _vm._s((_vm.value || []).length - _vm.myLimit))])])]) : _vm._e(), _vm._v(" "), _vm.multiple ? _c("template", {
    slot: "beforeList"
  }, [_c("span", {
    staticClass: "multiselect__action multiselect__option",
    class: {
      disabled: !_vm.isValueSet
    },
    on: {
      click: _vm.clearSelectedValue
    }
  }, [_c("small", [_vm._v("Clear selection")])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c("template", {
    slot: "afterList"
  }, [_vm._t("afterList")], 2)], 2)], 1);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-f0df3650_0", {
    source: "@charset \"UTF-8\";\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP BOOTSTRAP COLORS\n\n********************* */\n:export {\n  gray-color-white: #ffffff;\n  gray-color-alabaster: #fafafa;\n  gray-color-wild-sand: #f5f5f5;\n  gray-color-athens-gray: #eeeeef;\n  gray-color-geyser: #dee2e6;\n  gray-color-iron: #d7dce0;\n  gray-color-ghost: #ced4da;\n  gray-color-hit-gray: #adb5bd;\n  gray-color-regent-gray: #8c9ba5;\n  gray-color-oslo-gray: #868e96;\n  gray-color-trout: #495057;\n  gray-color-gray: #343a40;\n  gray-color-shark: #212529;\n  gray-color-black: #000000;\n  gray-color-ebony-clay: #1e272c;\n  blue-color-picton-blue: #2e8fe7;\n  blue-color-cornflower-blue: #58a5ec;\n  red-color-amaranth: #ef4853;\n  red-color-froly: #f26d75;\n  green-color-emerald: #3bbf74;\n  yellow-color-my-sin: #ffac1f;\n  yellow-color-texas-rose: #ffbd4c;\n  purple-color-wisteria: #9e5baa;\n  purple-color-light-wisteria: #d18edd;\n  others-color-burning-orange: #ff672c;\n  others-color-alto: #e0e0e0;\n  others-color-kumera: #8c641d;\n  others-color-pink: #e83e8c;\n  others-color-cyan: #17a2b8;\n  others-color-teal: #20c997;\n  others-color-east-bay: #39537a;\n  others-color-waikawa-gray: #576d8e;\n  others-color-zircon: #fafcff;\n  others-color-mystic: #dfe5eb;\n  others-color-casper: #b0bfd5;\n  others-color-heather: #b7c1cf;\n  others-color-fire-bush: #e6942c;\n  others-color-gold: #ffd200;\n  others-color-buttermilk: #ffecb3;\n  others-color-buttery-white: #fffceb;\n  others-color-indigo: #6610f2;\n  others-color-purple: #6f42c1;\n  others-color-studio: #9b48b3;\n}\n\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP BOOTSTRAP COLORS\n\n********************* */\n:export {\n  gray-color-white: #ffffff;\n  gray-color-alabaster: #fafafa;\n  gray-color-wild-sand: #f5f5f5;\n  gray-color-athens-gray: #eeeeef;\n  gray-color-geyser: #dee2e6;\n  gray-color-iron: #d7dce0;\n  gray-color-ghost: #ced4da;\n  gray-color-hit-gray: #adb5bd;\n  gray-color-regent-gray: #8c9ba5;\n  gray-color-oslo-gray: #868e96;\n  gray-color-trout: #495057;\n  gray-color-gray: #343a40;\n  gray-color-shark: #212529;\n  gray-color-black: #000000;\n  gray-color-ebony-clay: #1e272c;\n  blue-color-picton-blue: #2e8fe7;\n  blue-color-cornflower-blue: #58a5ec;\n  red-color-amaranth: #ef4853;\n  red-color-froly: #f26d75;\n  green-color-emerald: #3bbf74;\n  yellow-color-my-sin: #ffac1f;\n  yellow-color-texas-rose: #ffbd4c;\n  purple-color-wisteria: #9e5baa;\n  purple-color-light-wisteria: #d18edd;\n  others-color-burning-orange: #ff672c;\n  others-color-alto: #e0e0e0;\n  others-color-kumera: #8c641d;\n  others-color-pink: #e83e8c;\n  others-color-cyan: #17a2b8;\n  others-color-teal: #20c997;\n  others-color-east-bay: #39537a;\n  others-color-waikawa-gray: #576d8e;\n  others-color-zircon: #fafcff;\n  others-color-mystic: #dfe5eb;\n  others-color-casper: #b0bfd5;\n  others-color-heather: #b7c1cf;\n  others-color-fire-bush: #e6942c;\n  others-color-gold: #ffd200;\n  others-color-buttermilk: #ffecb3;\n  others-color-buttery-white: #fffceb;\n  others-color-indigo: #6610f2;\n  others-color-purple: #6f42c1;\n  others-color-studio: #9b48b3;\n}\n\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/* stylelint-enable color-no-hex */\n/*\nMixins\n======\n*/\n/*\nVueMultiselect\n==============\n*/\n.multiselect-wrapper {\n  width: 100%;\n}\n.multiselect-wrapper fieldset[disabled] .multiselect {\n  pointer-events: none;\n}\n.multiselect-wrapper .multiselect,\n.multiselect-wrapper .multiselect__input,\n.multiselect-wrapper .multiselect__single {\n  font-family: inherit;\n  font-size: inherit;\n  touch-action: manipulation;\n}\n.multiselect-wrapper .multiselect {\n  box-sizing: content-box;\n  display: block;\n  position: relative;\n  width: 100%;\n  min-height: calc(1em + 1rem + 2px);\n  text-align: left;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect * {\n  box-sizing: border-box;\n}\n.multiselect-wrapper .multiselect:focus {\n  outline: none;\n}\n.multiselect-wrapper .multiselect:not(.multiselect--active) {\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect--disabled {\n  background: #eeeeef;\n  pointer-events: none;\n  opacity: 0.65;\n}\n.multiselect-wrapper .multiselect--disabled .multiselect__current,\n.multiselect-wrapper .multiselect--disabled .multiselect__select {\n  background: #eeeeef;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect--active {\n  z-index: 50;\n}\n.multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__current, .multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__input, .multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__tags {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.multiselect-wrapper .multiselect--active.multiselect__select {\n  transform: rotateZ(180deg);\n}\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__current,\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__input,\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__tags {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.multiselect-wrapper .multiselect__input,\n.multiselect-wrapper .multiselect__single {\n  position: relative;\n  float: left;\n  min-height: calc(1em + 1rem + 2px)/2;\n  line-height: 1;\n  border: none;\n  border-radius: 0.125rem;\n  background: inherit;\n  padding: 0;\n  width: 100%;\n  transition: border 0.1s ease;\n  box-sizing: border-box;\n  margin-bottom: 0.25rem;\n  vertical-align: top;\n  overflow: hidden;\n  max-width: 100%;\n}\n.multiselect-wrapper .multiselect__single {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.multiselect-wrapper.multiple .multiselect__input {\n  position: absolute;\n  padding-bottom: 0.3em;\n  height: 1.8em;\n  max-width: calc(100% - 1em);\n}\n.multiselect-wrapper.multiple .input-wrapper .multiselect__input {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIuMDI1IiBoZWlnaHQ9IjUxMi4wMjUiIHZpZXdCb3g9IjAgMCA1MTIuMDI1IDUxMi4wMjUiPgogIDxwYXRoIGlkPSJzZWFyY2giIGQ9Ik01MDguNSw0NjguOSwzODcuMSwzNDcuNWExMS44NjksMTEuODY5LDAsMCwwLTguNS0zLjVIMzY1LjRBMjA3LjQzNywyMDcuNDM3LDAsMCwwLDQxNiwyMDhDNDE2LDkzLjEsMzIyLjksMCwyMDgsMFMwLDkzLjEsMCwyMDgsOTMuMSw0MTYsMjA4LDQxNmEyMDcuNDM3LDIwNy40MzcsMCwwLDAsMTM2LTUwLjZ2MTMuMmExMi4zLDEyLjMsMCwwLDAsMy41LDguNUw0NjguOSw1MDguNWExMi4wMTEsMTIuMDExLDAsMCwwLDE3LDBsMjIuNi0yMi42QTEyLjAxMSwxMi4wMTEsMCwwLDAsNTA4LjUsNDY4LjlaTTIwOCwzNjhBMTYwLDE2MCwwLDEsMSwzNjgsMjA4LDE1OS45NTYsMTU5Ljk1NiwwLDAsMSwyMDgsMzY4WiIgZmlsbD0iI2Q3ZGNlMCIvPgo8L3N2Zz4K\");\n  background-repeat: no-repeat;\n  background-position: right center;\n  background-size: 14px;\n  padding-right: 20px;\n}\n.multiselect-wrapper .multiselect__input::placeholder {\n  color: #868e96;\n}\n.multiselect-wrapper .multiselect__tag ~ .multiselect__input,\n.multiselect-wrapper .multiselect__tag ~ .multiselect__single {\n  width: auto;\n}\n.multiselect-wrapper .multiselect__input:hover,\n.multiselect-wrapper .multiselect__single:hover {\n  border-color: #ced4da;\n}\n.multiselect-wrapper .multiselect__input:focus,\n.multiselect-wrapper .multiselect__single:focus {\n  border-color: #adb5bd;\n  outline: none;\n}\n.multiselect-wrapper .input-wrapper {\n  border-bottom: 1px solid #eeeeef;\n}\n.multiselect-wrapper .input-wrapper .multiselect__input {\n  background-color: transparent;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  line-height: 32px;\n  height: auto;\n  text-indent: 8px;\n  float: none;\n}\n.multiselect-wrapper .multiselect__single {\n  padding: 0.25rem 0;\n}\n.multiselect-wrapper .multiselect__tags-wrap {\n  display: flex;\n  flex-wrap: nowrap;\n  min-width: 0;\n  overflow: hidden;\n}\n.multiselect-wrapper.calculating-limit .multiselect__tags-wrap {\n  display: block;\n}\n.multiselect-wrapper .multiselect__tags {\n  min-height: calc(1em + 1rem + 2px);\n  display: block;\n  padding: 0.25rem calc(1em + 1rem + 25px) 0 0.5rem;\n  border-radius: 0.125rem;\n  border: 1px solid #ced4da;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: inherit;\n}\n.multiselect-wrapper .multiselect__tags::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.multiselect-wrapper .multiselect__tags {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.multiselect-wrapper .multiselect__limit-pill {\n  flex: 0 0 auto;\n  padding-right: 10px;\n}\n.multiselect-wrapper .multiselect__tag {\n  position: relative;\n  float: left;\n  padding: 0.25rem 2.1rem 0.25rem 0.4rem;\n  border-radius: 0.125rem;\n  margin: 0 0.4rem 0.25rem 0;\n  color: #212529;\n  background: #ced4da;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  font-size: 100%;\n  font-weight: normal;\n}\n.multiselect-wrapper .multiselect__tag span {\n  display: block;\n  max-width: 50ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.multiselect-wrapper .multiselect__tag-icon {\n  cursor: pointer;\n  margin-left: 0.25rem;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-style: initial;\n  width: 1.7rem;\n  text-align: center;\n  line-height: 1.275rem;\n  transition: all 0.2s ease;\n  font-size: 50%;\n  font-weight: normal;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.multiselect-wrapper .multiselect__tag-icon::after {\n  content: \"×\";\n  color: #868e96;\n  font-size: 343%;\n  font-weight: 500;\n}\n.multiselect-wrapper .multiselect__tag-icon:focus,\n.multiselect-wrapper .multiselect__tag-icon:hover {\n  background: #868e96;\n}\n.multiselect-wrapper .multiselect__tag-icon:focus::after,\n.multiselect-wrapper .multiselect__tag-icon:hover::after {\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__current {\n  line-height: calc(1em + 1rem + 2px)/2;\n  min-height: calc(1em + 1rem + 2px);\n  box-sizing: border-box;\n  display: block;\n  overflow: hidden;\n  padding: 8px 30px 0 12px;\n  white-space: nowrap;\n  margin: 0;\n  text-decoration: none;\n  border-radius: 0.125rem;\n  border: 1px solid #ced4da;\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect__select {\n  line-height: calc(1em + 1rem + 2px)/2;\n  display: block;\n  position: absolute;\n  box-sizing: border-box;\n  width: calc(1em + 1rem + 2px);\n  height: calc(1em + 1rem + 2px);\n  right: 0;\n  top: 0;\n  padding: 8px 8px;\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  z-index: 2;\n}\n.multiselect-wrapper .multiselect__select::before {\n  position: relative;\n  right: 0;\n  top: 70%;\n  color: #8c9ba5;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #8c9ba5 transparent transparent transparent;\n  content: \"\";\n}\n.multiselect-wrapper .multiselect__placeholder {\n  color: #868e96;\n  display: inline-block;\n  margin-bottom: 6px;\n  padding-top: 0.25rem;\n  line-height: 1;\n}\n.multiselect-wrapper .multiselect--active .multiselect__placeholder {\n  display: none;\n}\n.multiselect-wrapper .multiselect__content-wrapper {\n  position: absolute;\n  display: block;\n  background: #ffffff;\n  width: auto;\n  min-width: 100%;\n  max-height: 240px;\n  max-width: 100%;\n  overflow: auto;\n  border: 1px solid #ced4da;\n  margin-top: -1px;\n  border-bottom-left-radius: 0.125rem;\n  border-bottom-right-radius: 0.125rem;\n  z-index: 50;\n  -webkit-overflow-scrolling: touch;\n}\n.multiselect-wrapper .multiselect__content {\n  list-style: none;\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  min-width: 100%;\n  max-width: 100%;\n  vertical-align: top;\n}\n.multiselect-wrapper .multiselect--above .multiselect__content-wrapper {\n  bottom: 100%;\n  border-radius: 0.125rem 0.125rem 0 0;\n  border-bottom: none;\n  border-top: 1px solid #ced4da;\n}\n.multiselect-wrapper .multiselect__content::-webkit-scrollbar {\n  display: none;\n}\n.multiselect-wrapper .multiselect__element {\n  display: block;\n}\n.multiselect-wrapper .multiselect__option {\n  display: block;\n  padding: 0.25rem 0.5rem;\n  min-height: 0;\n  line-height: 1.5rem;\n  text-decoration: none;\n  text-transform: none;\n  position: relative;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.multiselect-wrapper .multiselect__option::after {\n  top: 0;\n  right: 0;\n  position: absolute;\n  line-height: calc(1em + 1rem + 2px);\n  padding-right: 12px;\n  padding-left: 20px;\n  font-family: inherit;\n  font-size: inherit;\n}\n.multiselect-wrapper .checkbox_parent {\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n}\n.multiselect-wrapper .multiselect__checkbox {\n  margin-right: 9px;\n}\n.multiselect-wrapper .multiselect__checkbox + span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.multiselect-wrapper .multiselect__option--highlight {\n  background: #eeeeef;\n  outline: none;\n  color: #16181b;\n}\n.multiselect-wrapper .multiselect__option--highlight::after {\n  content: attr(data-select);\n  background: #eeeeef;\n  color: #16181b;\n}\n.multiselect-wrapper .multiselect__option--selected {\n  background: #576d8e;\n  color: #ffffff;\n  font-weight: normal;\n}\n.multiselect-wrapper .multiselect__option--selected::after {\n  content: attr(data-selected);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--selected.multiselect__option--highlight {\n  background: #39537a;\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--selected.multiselect__option--highlight::after {\n  background: #39537a;\n  content: attr(data-deselect);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--disabled {\n  background: #eeeeef;\n  color: #495057;\n  cursor: text;\n  pointer-events: none;\n}\n.multiselect-wrapper .multiselect__option--group {\n  background: #eeeeef;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect__option--group.multiselect__option--highlight {\n  background: #495057;\n  color: #eeeeef;\n}\n.multiselect-wrapper .multiselect__option--group.multiselect__option--highlight::after {\n  background: #495057;\n}\n.multiselect-wrapper .multiselect__option--disabled.multiselect__option--highlight {\n  background: #eeeeef;\n}\n.multiselect-wrapper .multiselect__option--group-selected.multiselect__option--highlight {\n  background: #39537a;\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--group-selected.multiselect__option--highlight::after {\n  background: #39537a;\n  content: attr(data-deselect);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__action:hover {\n  color: #2e8fe7;\n}\n.multiselect-wrapper .multiselect__action.disabled {\n  color: #868e96;\n  cursor: default;\n}\n.multiselect-wrapper .multiselect-enter-active,\n.multiselect-wrapper .multiselect-leave-active {\n  transition: all 0.15s ease;\n}\n.multiselect-wrapper .multiselect-enter,\n.multiselect-wrapper .multiselect-leave-active {\n  opacity: 0;\n}\n.multiselect-wrapper .multiselect__strong {\n  margin-bottom: 0.25rem;\n  line-height: calc(1em + 1rem + 2px)/2;\n  display: inline-block;\n  vertical-align: top;\n}\n.multiselect-wrapper .multiselect__clear-button {\n  position: absolute;\n  height: 100%;\n  right: 30px;\n  padding: 2px 0;\n  font-size: 1.3em;\n  z-index: 10;\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect__spinner {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: calc(1em + 1rem + 2px);\n  height: calc(1em + 1rem + 2px);\n  background: #eeeeef;\n  display: block;\n}\n.multiselect-wrapper .multiselect__spinner::before, .multiselect-wrapper .multiselect__spinner::after {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -8px 0 0 -8px;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  border: 2px solid transparent;\n  border-top-color: #343a40;\n  box-shadow: 0 0 0 1px transparent;\n}\n.multiselect-wrapper .multiselect__spinner::before {\n  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);\n  animation-iteration-count: infinite;\n}\n.multiselect-wrapper .multiselect__spinner::after {\n  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);\n  animation-iteration-count: infinite;\n}\n@keyframes spinning {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(2turn);\n}\n}\n.multiselect-wrapper .multiselect__loading-enter-active,\n.multiselect-wrapper .multiselect__loading-leave-active {\n  transition: opacity 0.4s ease-in-out;\n  opacity: 1;\n}\n.multiselect-wrapper .multiselect__loading-enter,\n.multiselect-wrapper .multiselect__loading-leave-active {\n  opacity: 0;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect {\n  text-align: right;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__select {\n  right: auto;\n  left: 1px;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__tags {\n  padding: 0.25rem 0.25rem 0 calc(1em + 1rem + 2px);\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__content {\n  text-align: right;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__option::after {\n  right: auto;\n  left: 0;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__clear {\n  right: auto;\n  left: 12px;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__spinner {\n  right: auto;\n  left: 1px;\n}\n\n/*# sourceMappingURL=Multiselect.vue.map */",
    map: {
      "version": 3,
      "sources": ["Multiselect.vue", "/home/circleci/project/packages/multiselect/Multiselect.vue"],
      "names": [],
      "mappings": "AAAA,gBAAgB;AAChB,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;ACmOlC;;;CAAA;AAaA;;;CAAA;AAgDA;EAIA,WAAA;ADzRA;AC2RA;EACA,oBAAA;ADzRA;AC4RA;;;EAGA,oBAAA;EACA,kBAAA;EACA,0BAAA;AD1RA;AC6RA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAuDA;EAtDA,gBAAA;EACA,cAAA;AD3RA;AC6RA;EACA,sBAAA;AD3RA;AC6RA;EACA,aAAA;AD3RA;AC6RA;EACA,eAAA;AD3RA;AC+RA;EACA,mBAAA;EACA,oBAAA;EACA,aA1BA;ADnQA;AC+RA;;EAEA,mBAAA;EACA,cAAA;AD7RA;ACiSA;EACA,WAAA;AD/RA;ACgSA;EAGA,4BAAA;EACA,6BAAA;ADhSA;ACmSA;EACA,0BAAA;ADjSA;ACqSA;;;EAGA,yBAAA;EACA,0BAAA;ADnSA;ACsSA;;EAEA,kBAAA;EACA,WAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBA9HA;EA+HA,mBAAA;EACA,gBAAA;EACA,eAAA;ADpSA;ACuSA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADrSA;ACwSA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,2BAAA;ADtSA;ACySA;EACA,usBAAA;EACA,4BAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;ADvSA;AC0SA;EACA,cAAA;ADxSA;AC2SA;;EAEA,WAAA;ADzSA;AC4SA;;EAEA,qBAAA;AD1SA;AC6SA;;EAEA,qBAAA;EACA,aAAA;AD3SA;AC8SA;EACA,gCAAA;AD5SA;AC8SA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AD5SA;ACgTA;EACA,kBAAA;AD9SA;ACiTA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AD/SA;ACkTA;EACA,cAAA;ADhTA;ACmTA;EACA,kCApFA;EAqFA,cAAA;EACA,iDAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;ADjTA;ACmTA;EACA,WAAA;EACA,cAAA;EACA,WAAA;ADjTA;ACqTA;EACA,aAAA;EACA,iBAAA;ADnTA;ACsTA;EACA,cAAA;EACA,mBAAA;ADpTA;ACuTA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EAGA,uBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,mBA/NA;ADxFA;AC0TA;EArQA,cAAA;EACA,eAoDA;EAnDA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADlDA;ACuTA;EACA,eAAA;EACA,oBAlOA;EAmOA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,aA7OA;EA8OA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAnPA;EAoPA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ADrTA;ACwTA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ADtTA;ACyTA;;EAEA,mBAAA;ADvTA;AC0TA;;EAEA,cAAA;ADxTA;AC2TA;EACA,qCAAA;EACA,kCA5KA;EA6KA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;ADzTA;AC4TA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BA9LA;EA+LA,8BA/LA;EAgMA,QAAA;EACA,MAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,UAAA;AD1TA;AC6TA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;EACA,WAAA;AD3TA;AC8TA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAlVA;EAmVA,cAAA;AD5TA;AC+TA;EACA,aAAA;AD7TA;ACgUA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,iCAAA;AD9TA;ACiUA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AD/TA;ACkUA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,6BAAA;ADhUA;ACmUA;EACA,aAAA;ADjUA;ACoUA;EACA,cAAA;ADlUA;ACqUA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADnUA;ACsUA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,mCA9RA;EA+RA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;ADpUA;ACuUA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;ADrUA;ACwUA;EACA,iBAAA;ADtUA;ACyUA;EACA,uBAAA;EACA,gBAAA;ADvUA;AC0UA;EACA,mBAAA;EACA,aAAA;EACA,cAxCA;ADhSA;AC2UA;EACA,0BAAA;EACA,mBAAA;EACA,cA9CA;AD3RA;AC4UA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AD1UA;AC6UA;EACA,4BAAA;EACA,cAAA;AD3UA;AC8UA;EACA,mBAAA;EACA,cAAA;AD5UA;AC+UA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;AD7UA;ACgVA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AD9UA;ACiVA;EACA,mBAAA;EACA,cAAA;AD/UA;ACiVA;EACA,mBAAA;EACA,cAAA;AD/UA;ACkVA;EACA,mBAAA;ADhVA;ACoVA;EACA,mBAAA;ADlVA;ACqVA;EACA,mBAAA;EACA,cAAA;ADnVA;ACsVA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;ADpVA;ACwVA;EACA,cAAA;ADtVA;ACwVA;EACA,cAAA;EACA,eAAA;ADtVA;AC0VA;;EAEA,0BAAA;ADxVA;AC2VA;;EAEA,UAAA;ADzVA;AC4VA;EACA,sBAvgBA;EAwgBA,qCAAA;EACA,qBAAA;EACA,mBAAA;AD1VA;AC6VA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AD3VA;ACkWA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAvaA;EAwaA,8BAxaA;EAyaA,mBAAA;EACA,cAAA;ADhWA;ACkWA;EAEA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,WAxgBA;EAygBA,YAzgBA;EA0gBA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;ADjWA;ACoWA;EACA,4DAAA;EACA,mCAAA;ADlWA;ACqWA;EACA,4DAAA;EACA,mCAAA;ADnWA;ACuWA;AACA;IACA,oBAAA;ADrWE;ACwWF;IACA,wBAAA;ADtWE;AACF;AC6WA;;EAEA,oCAAA;EACA,UAAA;AD3WA;AC8WA;;EAEA,UAAA;AD5WA;ACoXA;EACA,iBAAA;ADlXA;ACqXA;EACA,WAAA;EACA,SAAA;ADnXA;ACsXA;EACA,iDAAA;ADpXA;ACuXA;EACA,iBAAA;ADrXA;ACwXA;EACA,WAAA;EACA,OAAA;ADtXA;ACyXA;EACA,WAAA;EACA,UAAA;ADvXA;AC0XA;EACA,WAAA;EACA,SAAA;ADxXA;;AAEA,0CAA0C",
      "file": "Multiselect.vue",
      "sourcesContent": ["@charset \"UTF-8\";\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP BOOTSTRAP COLORS\n\n********************* */\n:export {\n  gray-color-white: #ffffff;\n  gray-color-alabaster: #fafafa;\n  gray-color-wild-sand: #f5f5f5;\n  gray-color-athens-gray: #eeeeef;\n  gray-color-geyser: #dee2e6;\n  gray-color-iron: #d7dce0;\n  gray-color-ghost: #ced4da;\n  gray-color-hit-gray: #adb5bd;\n  gray-color-regent-gray: #8c9ba5;\n  gray-color-oslo-gray: #868e96;\n  gray-color-trout: #495057;\n  gray-color-gray: #343a40;\n  gray-color-shark: #212529;\n  gray-color-black: #000000;\n  gray-color-ebony-clay: #1e272c;\n  blue-color-picton-blue: #2e8fe7;\n  blue-color-cornflower-blue: #58a5ec;\n  red-color-amaranth: #ef4853;\n  red-color-froly: #f26d75;\n  green-color-emerald: #3bbf74;\n  yellow-color-my-sin: #ffac1f;\n  yellow-color-texas-rose: #ffbd4c;\n  purple-color-wisteria: #9e5baa;\n  purple-color-light-wisteria: #d18edd;\n  others-color-burning-orange: #ff672c;\n  others-color-alto: #e0e0e0;\n  others-color-kumera: #8c641d;\n  others-color-pink: #e83e8c;\n  others-color-cyan: #17a2b8;\n  others-color-teal: #20c997;\n  others-color-east-bay: #39537a;\n  others-color-waikawa-gray: #576d8e;\n  others-color-zircon: #fafcff;\n  others-color-mystic: #dfe5eb;\n  others-color-casper: #b0bfd5;\n  others-color-heather: #b7c1cf;\n  others-color-fire-bush: #e6942c;\n  others-color-gold: #ffd200;\n  others-color-buttermilk: #ffecb3;\n  others-color-buttery-white: #fffceb;\n  others-color-indigo: #6610f2;\n  others-color-purple: #6f42c1;\n  others-color-studio: #9b48b3;\n}\n\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP BOOTSTRAP COLORS\n\n********************* */\n:export {\n  gray-color-white: #ffffff;\n  gray-color-alabaster: #fafafa;\n  gray-color-wild-sand: #f5f5f5;\n  gray-color-athens-gray: #eeeeef;\n  gray-color-geyser: #dee2e6;\n  gray-color-iron: #d7dce0;\n  gray-color-ghost: #ced4da;\n  gray-color-hit-gray: #adb5bd;\n  gray-color-regent-gray: #8c9ba5;\n  gray-color-oslo-gray: #868e96;\n  gray-color-trout: #495057;\n  gray-color-gray: #343a40;\n  gray-color-shark: #212529;\n  gray-color-black: #000000;\n  gray-color-ebony-clay: #1e272c;\n  blue-color-picton-blue: #2e8fe7;\n  blue-color-cornflower-blue: #58a5ec;\n  red-color-amaranth: #ef4853;\n  red-color-froly: #f26d75;\n  green-color-emerald: #3bbf74;\n  yellow-color-my-sin: #ffac1f;\n  yellow-color-texas-rose: #ffbd4c;\n  purple-color-wisteria: #9e5baa;\n  purple-color-light-wisteria: #d18edd;\n  others-color-burning-orange: #ff672c;\n  others-color-alto: #e0e0e0;\n  others-color-kumera: #8c641d;\n  others-color-pink: #e83e8c;\n  others-color-cyan: #17a2b8;\n  others-color-teal: #20c997;\n  others-color-east-bay: #39537a;\n  others-color-waikawa-gray: #576d8e;\n  others-color-zircon: #fafcff;\n  others-color-mystic: #dfe5eb;\n  others-color-casper: #b0bfd5;\n  others-color-heather: #b7c1cf;\n  others-color-fire-bush: #e6942c;\n  others-color-gold: #ffd200;\n  others-color-buttermilk: #ffecb3;\n  others-color-buttery-white: #fffceb;\n  others-color-indigo: #6610f2;\n  others-color-purple: #6f42c1;\n  others-color-studio: #9b48b3;\n}\n\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/* stylelint-enable color-no-hex */\n/*\nMixins\n======\n*/\n/*\nVueMultiselect\n==============\n*/\n.multiselect-wrapper {\n  width: 100%;\n}\n.multiselect-wrapper fieldset[disabled] .multiselect {\n  pointer-events: none;\n}\n.multiselect-wrapper .multiselect,\n.multiselect-wrapper .multiselect__input,\n.multiselect-wrapper .multiselect__single {\n  font-family: inherit;\n  font-size: inherit;\n  touch-action: manipulation;\n}\n.multiselect-wrapper .multiselect {\n  box-sizing: content-box;\n  display: block;\n  position: relative;\n  width: 100%;\n  min-height: calc(1em + 1rem + 2px);\n  text-align: left;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect * {\n  box-sizing: border-box;\n}\n.multiselect-wrapper .multiselect:focus {\n  outline: none;\n}\n.multiselect-wrapper .multiselect:not(.multiselect--active) {\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect--disabled {\n  background: #eeeeef;\n  pointer-events: none;\n  opacity: 0.65;\n}\n.multiselect-wrapper .multiselect--disabled .multiselect__current,\n.multiselect-wrapper .multiselect--disabled .multiselect__select {\n  background: #eeeeef;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect--active {\n  z-index: 50;\n}\n.multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__current, .multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__input, .multiselect-wrapper .multiselect--active:not(.multiselect--above) .multiselect__tags {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.multiselect-wrapper .multiselect--active.multiselect__select {\n  transform: rotateZ(180deg);\n}\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__current,\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__input,\n.multiselect-wrapper .multiselect--above.multiselect--active .multiselect__tags {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.multiselect-wrapper .multiselect__input,\n.multiselect-wrapper .multiselect__single {\n  position: relative;\n  float: left;\n  min-height: calc(1em + 1rem + 2px)/2;\n  line-height: 1;\n  border: none;\n  border-radius: 0.125rem;\n  background: inherit;\n  padding: 0;\n  width: 100%;\n  transition: border 0.1s ease;\n  box-sizing: border-box;\n  margin-bottom: 0.25rem;\n  vertical-align: top;\n  overflow: hidden;\n  max-width: 100%;\n}\n.multiselect-wrapper .multiselect__single {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.multiselect-wrapper.multiple .multiselect__input {\n  position: absolute;\n  padding-bottom: 0.3em;\n  height: 1.8em;\n  max-width: calc(100% - 1em);\n}\n.multiselect-wrapper.multiple .input-wrapper .multiselect__input {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIuMDI1IiBoZWlnaHQ9IjUxMi4wMjUiIHZpZXdCb3g9IjAgMCA1MTIuMDI1IDUxMi4wMjUiPgogIDxwYXRoIGlkPSJzZWFyY2giIGQ9Ik01MDguNSw0NjguOSwzODcuMSwzNDcuNWExMS44NjksMTEuODY5LDAsMCwwLTguNS0zLjVIMzY1LjRBMjA3LjQzNywyMDcuNDM3LDAsMCwwLDQxNiwyMDhDNDE2LDkzLjEsMzIyLjksMCwyMDgsMFMwLDkzLjEsMCwyMDgsOTMuMSw0MTYsMjA4LDQxNmEyMDcuNDM3LDIwNy40MzcsMCwwLDAsMTM2LTUwLjZ2MTMuMmExMi4zLDEyLjMsMCwwLDAsMy41LDguNUw0NjguOSw1MDguNWExMi4wMTEsMTIuMDExLDAsMCwwLDE3LDBsMjIuNi0yMi42QTEyLjAxMSwxMi4wMTEsMCwwLDAsNTA4LjUsNDY4LjlaTTIwOCwzNjhBMTYwLDE2MCwwLDEsMSwzNjgsMjA4LDE1OS45NTYsMTU5Ljk1NiwwLDAsMSwyMDgsMzY4WiIgZmlsbD0iI2Q3ZGNlMCIvPgo8L3N2Zz4K\");\n  background-repeat: no-repeat;\n  background-position: right center;\n  background-size: 14px;\n  padding-right: 20px;\n}\n.multiselect-wrapper .multiselect__input::placeholder {\n  color: #868e96;\n}\n.multiselect-wrapper .multiselect__tag ~ .multiselect__input,\n.multiselect-wrapper .multiselect__tag ~ .multiselect__single {\n  width: auto;\n}\n.multiselect-wrapper .multiselect__input:hover,\n.multiselect-wrapper .multiselect__single:hover {\n  border-color: #ced4da;\n}\n.multiselect-wrapper .multiselect__input:focus,\n.multiselect-wrapper .multiselect__single:focus {\n  border-color: #adb5bd;\n  outline: none;\n}\n.multiselect-wrapper .input-wrapper {\n  border-bottom: 1px solid #eeeeef;\n}\n.multiselect-wrapper .input-wrapper .multiselect__input {\n  background-color: transparent;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  line-height: 32px;\n  height: auto;\n  text-indent: 8px;\n  float: none;\n}\n.multiselect-wrapper .multiselect__single {\n  padding: 0.25rem 0;\n}\n.multiselect-wrapper .multiselect__tags-wrap {\n  display: flex;\n  flex-wrap: nowrap;\n  min-width: 0;\n  overflow: hidden;\n}\n.multiselect-wrapper.calculating-limit .multiselect__tags-wrap {\n  display: block;\n}\n.multiselect-wrapper .multiselect__tags {\n  min-height: calc(1em + 1rem + 2px);\n  display: block;\n  padding: 0.25rem calc(1em + 1rem + 25px) 0 0.5rem;\n  border-radius: 0.125rem;\n  border: 1px solid #ced4da;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: inherit;\n}\n.multiselect-wrapper .multiselect__tags::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.multiselect-wrapper .multiselect__tags {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.multiselect-wrapper .multiselect__limit-pill {\n  flex: 0 0 auto;\n  padding-right: 10px;\n}\n.multiselect-wrapper .multiselect__tag {\n  position: relative;\n  float: left;\n  padding: 0.25rem 2.1rem 0.25rem 0.4rem;\n  border-radius: 0.125rem;\n  margin: 0 0.4rem 0.25rem 0;\n  color: #212529;\n  background: #ced4da;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  font-size: 100%;\n  font-weight: normal;\n}\n.multiselect-wrapper .multiselect__tag span {\n  display: block;\n  max-width: 50ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.multiselect-wrapper .multiselect__tag-icon {\n  cursor: pointer;\n  margin-left: 0.25rem;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-style: initial;\n  width: 1.7rem;\n  text-align: center;\n  line-height: 1.275rem;\n  transition: all 0.2s ease;\n  font-size: 50%;\n  font-weight: normal;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.multiselect-wrapper .multiselect__tag-icon::after {\n  content: \"×\";\n  color: #868e96;\n  font-size: 343%;\n  font-weight: 500;\n}\n.multiselect-wrapper .multiselect__tag-icon:focus,\n.multiselect-wrapper .multiselect__tag-icon:hover {\n  background: #868e96;\n}\n.multiselect-wrapper .multiselect__tag-icon:focus::after,\n.multiselect-wrapper .multiselect__tag-icon:hover::after {\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__current {\n  line-height: calc(1em + 1rem + 2px)/2;\n  min-height: calc(1em + 1rem + 2px);\n  box-sizing: border-box;\n  display: block;\n  overflow: hidden;\n  padding: 8px 30px 0 12px;\n  white-space: nowrap;\n  margin: 0;\n  text-decoration: none;\n  border-radius: 0.125rem;\n  border: 1px solid #ced4da;\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect__select {\n  line-height: calc(1em + 1rem + 2px)/2;\n  display: block;\n  position: absolute;\n  box-sizing: border-box;\n  width: calc(1em + 1rem + 2px);\n  height: calc(1em + 1rem + 2px);\n  right: 0;\n  top: 0;\n  padding: 8px 8px;\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  z-index: 2;\n}\n.multiselect-wrapper .multiselect__select::before {\n  position: relative;\n  right: 0;\n  top: 70%;\n  color: #8c9ba5;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #8c9ba5 transparent transparent transparent;\n  content: \"\";\n}\n.multiselect-wrapper .multiselect__placeholder {\n  color: #868e96;\n  display: inline-block;\n  margin-bottom: 6px;\n  padding-top: 0.25rem;\n  line-height: 1;\n}\n.multiselect-wrapper .multiselect--active .multiselect__placeholder {\n  display: none;\n}\n.multiselect-wrapper .multiselect__content-wrapper {\n  position: absolute;\n  display: block;\n  background: #ffffff;\n  width: auto;\n  min-width: 100%;\n  max-height: 240px;\n  max-width: 100%;\n  overflow: auto;\n  border: 1px solid #ced4da;\n  margin-top: -1px;\n  border-bottom-left-radius: 0.125rem;\n  border-bottom-right-radius: 0.125rem;\n  z-index: 50;\n  -webkit-overflow-scrolling: touch;\n}\n.multiselect-wrapper .multiselect__content {\n  list-style: none;\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  min-width: 100%;\n  max-width: 100%;\n  vertical-align: top;\n}\n.multiselect-wrapper .multiselect--above .multiselect__content-wrapper {\n  bottom: 100%;\n  border-radius: 0.125rem 0.125rem 0 0;\n  border-bottom: none;\n  border-top: 1px solid #ced4da;\n}\n.multiselect-wrapper .multiselect__content::-webkit-scrollbar {\n  display: none;\n}\n.multiselect-wrapper .multiselect__element {\n  display: block;\n}\n.multiselect-wrapper .multiselect__option {\n  display: block;\n  padding: 0.25rem 0.5rem;\n  min-height: 0;\n  line-height: 1.5rem;\n  text-decoration: none;\n  text-transform: none;\n  position: relative;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.multiselect-wrapper .multiselect__option::after {\n  top: 0;\n  right: 0;\n  position: absolute;\n  line-height: calc(1em + 1rem + 2px);\n  padding-right: 12px;\n  padding-left: 20px;\n  font-family: inherit;\n  font-size: inherit;\n}\n.multiselect-wrapper .checkbox_parent {\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n}\n.multiselect-wrapper .multiselect__checkbox {\n  margin-right: 9px;\n}\n.multiselect-wrapper .multiselect__checkbox + span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.multiselect-wrapper .multiselect__option--highlight {\n  background: #eeeeef;\n  outline: none;\n  color: #16181b;\n}\n.multiselect-wrapper .multiselect__option--highlight::after {\n  content: attr(data-select);\n  background: #eeeeef;\n  color: #16181b;\n}\n.multiselect-wrapper .multiselect__option--selected {\n  background: #576d8e;\n  color: #ffffff;\n  font-weight: normal;\n}\n.multiselect-wrapper .multiselect__option--selected::after {\n  content: attr(data-selected);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--selected.multiselect__option--highlight {\n  background: #39537a;\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--selected.multiselect__option--highlight::after {\n  background: #39537a;\n  content: attr(data-deselect);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--disabled {\n  background: #eeeeef;\n  color: #495057;\n  cursor: text;\n  pointer-events: none;\n}\n.multiselect-wrapper .multiselect__option--group {\n  background: #eeeeef;\n  color: #495057;\n}\n.multiselect-wrapper .multiselect__option--group.multiselect__option--highlight {\n  background: #495057;\n  color: #eeeeef;\n}\n.multiselect-wrapper .multiselect__option--group.multiselect__option--highlight::after {\n  background: #495057;\n}\n.multiselect-wrapper .multiselect__option--disabled.multiselect__option--highlight {\n  background: #eeeeef;\n}\n.multiselect-wrapper .multiselect__option--group-selected.multiselect__option--highlight {\n  background: #39537a;\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__option--group-selected.multiselect__option--highlight::after {\n  background: #39537a;\n  content: attr(data-deselect);\n  color: #ffffff;\n}\n.multiselect-wrapper .multiselect__action:hover {\n  color: #2e8fe7;\n}\n.multiselect-wrapper .multiselect__action.disabled {\n  color: #868e96;\n  cursor: default;\n}\n.multiselect-wrapper .multiselect-enter-active,\n.multiselect-wrapper .multiselect-leave-active {\n  transition: all 0.15s ease;\n}\n.multiselect-wrapper .multiselect-enter,\n.multiselect-wrapper .multiselect-leave-active {\n  opacity: 0;\n}\n.multiselect-wrapper .multiselect__strong {\n  margin-bottom: 0.25rem;\n  line-height: calc(1em + 1rem + 2px)/2;\n  display: inline-block;\n  vertical-align: top;\n}\n.multiselect-wrapper .multiselect__clear-button {\n  position: absolute;\n  height: 100%;\n  right: 30px;\n  padding: 2px 0;\n  font-size: 1.3em;\n  z-index: 10;\n  cursor: pointer;\n}\n.multiselect-wrapper .multiselect__spinner {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: calc(1em + 1rem + 2px);\n  height: calc(1em + 1rem + 2px);\n  background: #eeeeef;\n  display: block;\n}\n.multiselect-wrapper .multiselect__spinner::before, .multiselect-wrapper .multiselect__spinner::after {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -8px 0 0 -8px;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  border: 2px solid transparent;\n  border-top-color: #343a40;\n  box-shadow: 0 0 0 1px transparent;\n}\n.multiselect-wrapper .multiselect__spinner::before {\n  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);\n  animation-iteration-count: infinite;\n}\n.multiselect-wrapper .multiselect__spinner::after {\n  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);\n  animation-iteration-count: infinite;\n}\n@keyframes spinning {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(2turn);\n  }\n}\n.multiselect-wrapper .multiselect__loading-enter-active,\n.multiselect-wrapper .multiselect__loading-leave-active {\n  transition: opacity 0.4s ease-in-out;\n  opacity: 1;\n}\n.multiselect-wrapper .multiselect__loading-enter,\n.multiselect-wrapper .multiselect__loading-leave-active {\n  opacity: 0;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect {\n  text-align: right;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__select {\n  right: auto;\n  left: 1px;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__tags {\n  padding: 0.25rem 0.25rem 0 calc(1em + 1rem + 2px);\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__content {\n  text-align: right;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__option::after {\n  right: auto;\n  left: 0;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__clear {\n  right: auto;\n  left: 12px;\n}\n.multiselect-wrapper *[dir=rtl] .multiselect__spinner {\n  right: auto;\n  left: 1px;\n}\n\n/*# sourceMappingURL=Multiselect.vue.map */", "<template>\n  <div\n    v-resize=\"onResize\"\n    class=\"multiselect-wrapper\"\n    :class=\"{\n      'calculating-limit': calculatingLimit,\n      multiple: multiple\n    }\"\n  >\n    <vue-multiselect\n      :name=\"name\"\n      :multiple=\"multiple\"\n      :search-in-dropdown=\"multiple\"\n      :disabled=\"disabled\"\n      :class=\"validationClass\"\n      :options=\"myOptions\"\n      :option-height=\"35\"\n      :value=\"value\"\n      :allow-empty=\"allowEmpty\"\n      :show-labels=\"false\"\n      :label=\"label\"\n      :custom-label=\"customLabel\"\n      :limit=\"myLimit\"\n      v-bind=\"$attrs\"\n      v-on=\"$listeners\"\n      @input=\"onChange\"\n      @open=\"onOpen\"\n      @close=\"onClose\"\n    >\n      <!--\n        TODO: clean up when this is merged:\n        https://github.com/vuejs/vue/pull/7765\n      -->\n      <template\n        v-for=\"(slot, slotName) in $scopedSlots\"\n        :slot=\"slotName\"\n        slot-scope=\"props\"\n      >\n        <slot v-bind=\"props\" :name=\"slotName\" />\n      </template>\n\n      <template v-if=\"multiple\" slot=\"limit\">\n        <span class=\"multiselect__tag multiselect__limit-pill\">\n          <span>+{{ (value || []).length - myLimit }}</span>\n        </span>\n      </template>\n\n      <template v-if=\"multiple\" slot=\"beforeList\">\n        <span\n          class=\"multiselect__action multiselect__option\"\n          :class=\"{ disabled: !isValueSet }\"\n          @click=\"clearSelectedValue\"\n          ><small>Clear selection</small></span\n        >\n      </template>\n\n      <template\n        v-if=\"checkboxesVisible\"\n        :slot=\"checkboxesVisible ? 'option' : ''\"\n        slot-scope=\"props\"\n      >\n        <div class=\"checkbox_parent\">\n          <input\n            type=\"checkbox\"\n            class=\"multiselect__checkbox\"\n            :checked=\"isSelected(props.option)\"\n          />\n          <span>\n            {{ getOptionLabel(props.option) }}\n          </span>\n        </div>\n      </template>\n\n      <template v-slot:clear>\n        <!-- Render hidden select element for form posting -->\n        <select\n          v-if=\"renderSelectElement\"\n          :multiple=\"multiple\"\n          :name=\"name\"\n          class=\"d-none\"\n        >\n          <option\n            v-for=\"option in valueArray\"\n            :key=\"option ? option.value : null\"\n            :value=\"option ? option.value : null\"\n            selected\n            >{{ option ? option.label : null }}</option\n          >\n        </select>\n\n        <div\n          v-show=\"isValueSet && allowEmpty && !disabled\"\n          class=\"multiselect__clear-button\"\n          @mousedown.prevent=\"clearSelectedValue\"\n        >\n          ×\n        </div>\n\n        <!-- Add child clear slot so people can still extend the VueMultiselect slot -->\n        <slot name=\"clear\"></slot>\n      </template>\n\n      <template slot=\"afterList\">\n        <slot name=\"afterList\" />\n      </template>\n    </vue-multiselect>\n  </div>\n</template>\n\n<script>\nimport Vue from \"vue\";\nimport VueMultiselect from \"vue-multiselect\";\nimport isObject from \"lodash.isobject\";\nimport \"vue-multiselect/dist/vue-multiselect.min.css\";\nimport cloneDeep from \"lodash.clonedeep\";\nimport VueResizeObserver from \"vue-resize-observer\";\n\nVue.use(VueResizeObserver);\n\nconst formatOptions = options => {\n  return options.forEach(option => {\n    if (isObject(option) && \"disabled\" in option) {\n      option[\"$isDisabled\"] = option[\"disabled\"];\n      delete option[\"disabled\"];\n    }\n  });\n};\n\nexport const isEqual = (a, b) => {\n  if (typeof a !== typeof b) return false;\n  if (Array.isArray(a) !== Array.isArray(b)) return false;\n\n  if (typeof a === \"object\") {\n    // Prevent circular reference:\n    if (a === b) return true;\n\n    for (let key in a) {\n      if (!Object.prototype.hasOwnProperty.call(a, key)) continue;\n\n      if (typeof a[key] !== typeof b[key]) return false;\n\n      if (typeof a[key] === \"object\") {\n        if (!isEqual(a[key], b[key])) return false;\n      } else if (a[key] !== b[key]) {\n        return false;\n      }\n    }\n    // Check that every key from b also exists in a:\n    for (let key in b) {\n      if (typeof b[key] !== typeof a[key]) return false;\n    }\n    return true;\n  }\n  return a === b;\n};\n\n// Copied from node_modules/vue-multiselect/src/multiselectMixin.js:\nfunction isEmpty(opt) {\n  if (opt === 0) return false;\n  if (Array.isArray(opt) && opt.length === 0) return true;\n  return !opt;\n}\n\nconst UNLIMITED = 99999;\n\nexport default {\n  name: \"ZenMultiselect\",\n  components: { VueMultiselect },\n  props: {\n    allowEmpty: {\n      type: Boolean,\n      default: true\n    },\n    name: {\n      type: String,\n      default: \"\"\n    },\n    multiple: {\n      type: Boolean,\n      default: false\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    options: {\n      type: Array,\n      required: false,\n      default: () => []\n    },\n    renderSelectElement: {\n      type: Boolean,\n      default: false\n    },\n    value: {\n      type: [Object, String, Array, Number],\n      default: null\n    },\n    valid: {\n      type: Boolean,\n      default: null\n    },\n    showCheckboxes: {\n      type: Boolean,\n      default: true\n    },\n    customLabel: {\n      type: Function,\n      default: (option, label) =>\n        isEmpty(option) ? \"\" : label ? option[label] : option\n    },\n    label: {\n      type: String,\n      default: \"\"\n    },\n    limit: {\n      type: Number,\n      default: UNLIMITED\n    },\n    customOptionSlot: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data: function() {\n    return {\n      myLimit: UNLIMITED,\n      myOptions: [],\n      calculatingLimit: false\n    };\n  },\n  computed: {\n    validationClass() {\n      if (this.valid === null) {\n        return \"\";\n      }\n      return this.valid ? \"is-valid\" : \"is-invalid\";\n    },\n    valueArray() {\n      return Array.isArray(this.value)\n        ? this.value\n        : this.value && Object.keys(this.value).length\n        ? [this.value]\n        : [];\n    },\n    isValueSet() {\n      return !!this.valueArray.length;\n    },\n    checkboxesVisible() {\n      return !this.customOptionSlot && this.multiple && this.showCheckboxes;\n    }\n  },\n  watch: {\n    options: {\n      immediate: true,\n      deep: true,\n      handler: function(value) {\n        formatOptions(value);\n        this.myOptions = cloneDeep(value);\n        this.orderOptions();\n        this.calcLimit();\n      }\n    }\n  },\n  created: function() {\n    formatOptions(this.options);\n  },\n  methods: {\n    clearSelectedValue() {\n      const emptyValue = this.multiple ? [] : null;\n      this.$emit(\"input\", emptyValue);\n    },\n    async calcLimit() {\n      if (!this.multiple) return;\n\n      this.calculatingLimit = true;\n      this.myLimit = UNLIMITED;\n      await this.$nextTick();\n\n      const items = this.$el.querySelectorAll(\n        \".multiselect__tags .multiselect__tag\"\n      );\n      const width = this.$el.offsetWidth - 140;\n      let x = 0;\n      let i = 0;\n      while (items[i]) {\n        x += items[i].offsetWidth;\n        if (x > width) break;\n        i++;\n      }\n      this.calculatingLimit = false;\n      this.myLimit = Math.max(i, 1);\n    },\n    onChange() {\n      this.calcLimit();\n    },\n    onOpen() {\n      if (!this.multiple) return;\n      this.myOptions = cloneDeep(this.options);\n      this.orderOptions();\n      this.$nextTick(() => {\n        let el = this.$el.querySelectorAll(\".multiselect__content-wrapper\")[0];\n        el.scroll(0, 0);\n      });\n    },\n    onClose() {\n      this.calcLimit();\n    },\n    onResize(value) {\n      if (!value.width || value.width === this.lastWidth) return;\n      this.lastWidth = value.width;\n      this.debounceCalcLimit();\n    },\n    debounceCalcLimit(time = 300) {\n      clearTimeout(this.calcLimitTimer);\n      this.calcLimitTimer = setTimeout(this.calcLimit, time);\n    },\n    isSelected(option) {\n      for (let b of this.value || []) {\n        if (isEqual(b, option)) {\n          return true;\n        }\n      }\n    },\n    orderOptions() {\n      if (!Array.isArray(this.value)) return;\n      // Reorder items, so that selected are on top:\n      let selected = this.myOptions.filter(a => this.isSelected(a, this.value));\n      let unSelected = this.myOptions.filter(\n        a => !this.isSelected(a, this.value)\n      );\n      this.myOptions = selected.concat(unSelected);\n    },\n    // Copied from node_modules/vue-multiselect/src/multiselectMixin.js:\n    getOptionLabel(option) {\n      if (isEmpty(option)) return \"\";\n      /* istanbul ignore else */\n      if (option.isTag) return option.label;\n      /* istanbul ignore else */\n      if (option.$isLabel) return option.$groupLabel;\n\n      let label = this.customLabel(option, this.label);\n      /* istanbul ignore else */\n      if (isEmpty(label)) return \"\";\n      return label;\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\">\n@import \"@reciprocity/bootstrap/scss/custom\";\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n/*\nMixins\n======\n*/\n\n@mixin truncate($max-width) {\n  display: block;\n  max-width: $max-width;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/*\nVueMultiselect\n==============\n*/\n\n$vue-ms-padding-x: $input-padding-x;\n$vue-ms-padding-y: $input-padding-y / 2;\n$vue-ms-min-height: $input-height;\n$vue-ms-border-radius: $border-radius;\n$vue-ms-border-color: $input-border-color;\n$vue-ms-border-width: $border-width-default;\n$vue-ms-disabled-opacity: $btn-disabled-opacity;\n$vue-ms-placeholder-color: $input-placeholder-color;\n$vue-ms-bg: $input-bg;\n$vue-ms-color: $input-color;\n$vue-ms-disabled-bg: $input-disabled-bg;\n$vue-ms-disabled-color: $input-color;\n\n$vue-ms-option-selected-bg: $dropdown-link-active-bg;\n$vue-ms-option-selected-color: $dropdown-link-active-color;\n$vue-ms-option-highlight-color: $dropdown-link-hover-color;\n$vue-ms-option-highlight-bg: $dropdown-link-hover-bg;\n$vue-ms-option-selected-highlight-color: $dropdown-link-active-color;\n$vue-ms-option-selected-highlight-bg: $dropdown-link-active-hover-bg;\n\n$vue-ms-tag-color: $color-text-default;\n$vue-ms-tag-bg: $color-ghost;\n$vue-ms-tag-font-size: $badge-font-size;\n$vue-ms-tag-font-weight: normal;\n$vue-ms-tag-icon-size: 1.7rem;\n$vue-ms-tag-icon-color: $color-oslo-gray;\n$vue-ms-tag-icon-color-hover: $color-white;\n$vue-ms-tag-icon-bg-hover: $color-oslo-gray;\n$vue-ms-tag-padding-x: 0.4rem;\n$vue-ms-tag-padding-y: 0.25rem;\n$vue-ms-tag-border-radius: $badge-border-radius;\n\n$vue-ms-arrow-color: $color-regent-gray;\n$vue-ms-arrow-size: 5px;\n$vue-ms-arrow-padding: 8px;\n\n$vue-ms-spinner-size: 16px;\n$vue-ms-spinner-thickness: 2px;\n$vue-ms-spinner-margin: -$vue-ms-spinner-size / 2;\n$vue-ms-spinner-color: $dark;\n\n$title-truncate-width: 50ch;\n\n.multiselect-wrapper {\n  // --------------------------------\n  // Select field\n  // --\n  width: 100%;\n\n  fieldset[disabled] .multiselect {\n    pointer-events: none;\n  }\n\n  .multiselect,\n  .multiselect__input,\n  .multiselect__single {\n    font-family: inherit;\n    font-size: inherit;\n    touch-action: manipulation;\n  }\n\n  .multiselect {\n    box-sizing: content-box;\n    display: block;\n    position: relative;\n    width: 100%;\n    min-height: $vue-ms-min-height;\n    text-align: left;\n    color: $vue-ms-color;\n\n    * {\n      box-sizing: border-box;\n    }\n    &:focus {\n      outline: none;\n    }\n    &:not(.multiselect--active) {\n      cursor: pointer;\n    }\n  }\n\n  .multiselect--disabled {\n    background: $vue-ms-disabled-bg;\n    pointer-events: none;\n    opacity: $vue-ms-disabled-opacity;\n\n    .multiselect__current,\n    .multiselect__select {\n      background: $vue-ms-disabled-bg;\n      color: $vue-ms-disabled-color;\n    }\n  }\n\n  .multiselect--active {\n    z-index: 50;\n    &:not(.multiselect--above) .multiselect__current,\n    &:not(.multiselect--above) .multiselect__input,\n    &:not(.multiselect--above) .multiselect__tags {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    &.multiselect__select {\n      transform: rotateZ(180deg);\n    }\n  }\n\n  .multiselect--above.multiselect--active .multiselect__current,\n  .multiselect--above.multiselect--active .multiselect__input,\n  .multiselect--above.multiselect--active .multiselect__tags {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .multiselect__input,\n  .multiselect__single {\n    position: relative;\n    float: left;\n    min-height: $vue-ms-min-height / 2;\n    line-height: 1;\n    border: none;\n    border-radius: $vue-ms-border-radius;\n    background: inherit;\n    padding: 0;\n    width: 100%;\n    transition: border 0.1s ease;\n    box-sizing: border-box;\n    margin-bottom: $vue-ms-padding-y;\n    vertical-align: top;\n    overflow: hidden;\n    max-width: 100%;\n  }\n\n  .multiselect__single {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &.multiple .multiselect__input {\n    position: absolute;\n    padding-bottom: 0.3em;\n    height: 1.8em;\n    max-width: calc(100% - 1em);\n  }\n\n  &.multiple .input-wrapper .multiselect__input {\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIuMDI1IiBoZWlnaHQ9IjUxMi4wMjUiIHZpZXdCb3g9IjAgMCA1MTIuMDI1IDUxMi4wMjUiPgogIDxwYXRoIGlkPSJzZWFyY2giIGQ9Ik01MDguNSw0NjguOSwzODcuMSwzNDcuNWExMS44NjksMTEuODY5LDAsMCwwLTguNS0zLjVIMzY1LjRBMjA3LjQzNywyMDcuNDM3LDAsMCwwLDQxNiwyMDhDNDE2LDkzLjEsMzIyLjksMCwyMDgsMFMwLDkzLjEsMCwyMDgsOTMuMSw0MTYsMjA4LDQxNmEyMDcuNDM3LDIwNy40MzcsMCwwLDAsMTM2LTUwLjZ2MTMuMmExMi4zLDEyLjMsMCwwLDAsMy41LDguNUw0NjguOSw1MDguNWExMi4wMTEsMTIuMDExLDAsMCwwLDE3LDBsMjIuNi0yMi42QTEyLjAxMSwxMi4wMTEsMCwwLDAsNTA4LjUsNDY4LjlaTTIwOCwzNjhBMTYwLDE2MCwwLDEsMSwzNjgsMjA4LDE1OS45NTYsMTU5Ljk1NiwwLDAsMSwyMDgsMzY4WiIgZmlsbD0iI2Q3ZGNlMCIvPgo8L3N2Zz4K\");\n    background-repeat: no-repeat;\n    background-position: right center;\n    background-size: 14px;\n    padding-right: 20px;\n  }\n\n  .multiselect__input::placeholder {\n    color: $vue-ms-placeholder-color;\n  }\n\n  .multiselect__tag ~ .multiselect__input,\n  .multiselect__tag ~ .multiselect__single {\n    width: auto;\n  }\n\n  .multiselect__input:hover,\n  .multiselect__single:hover {\n    border-color: $color-ghost;\n  }\n\n  .multiselect__input:focus,\n  .multiselect__single:focus {\n    border-color: $color-hit-gray;\n    outline: none;\n  }\n\n  .input-wrapper {\n    border-bottom: 1px solid $color-athens-gray;\n\n    .multiselect__input {\n      background-color: transparent;\n      position: relative;\n      margin: 0;\n      padding: 0;\n      line-height: 32px;\n      height: auto;\n      text-indent: 8px;\n      float: none;\n    }\n  }\n\n  .multiselect__single {\n    padding: $vue-ms-padding-y 0;\n  }\n\n  .multiselect__tags-wrap {\n    display: flex;\n    flex-wrap: nowrap;\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  &.calculating-limit .multiselect__tags-wrap {\n    display: block;\n  }\n\n  .multiselect__tags {\n    min-height: $vue-ms-min-height;\n    display: block;\n    padding: $vue-ms-padding-y calc(1em + 1rem + 25px) 0 $vue-ms-padding-x;\n    border-radius: $vue-ms-border-radius;\n    border: $vue-ms-border-width solid $vue-ms-border-color;\n    background: $custom-select-bg;\n    font-family: inherit;\n    font-size: inherit;\n\n    &::after {\n      content: \"\";\n      display: table;\n      clear: both;\n    }\n  }\n\n  .multiselect__tags {\n    display: flex;\n    flex-wrap: nowrap;\n  }\n\n  .multiselect__limit-pill {\n    flex: 0 0 auto;\n    padding-right: 10px;\n  }\n\n  .multiselect__tag {\n    position: relative;\n    float: left;\n    padding: $vue-ms-tag-padding-y\n      ($vue-ms-tag-icon-size + $vue-ms-tag-padding-x) $vue-ms-tag-padding-y\n      $vue-ms-tag-padding-x;\n    border-radius: $vue-ms-tag-border-radius;\n    margin: 0 $vue-ms-tag-padding-x $vue-ms-tag-padding-y 0;\n    color: $vue-ms-tag-color;\n    background: $vue-ms-tag-bg;\n    white-space: nowrap;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n    font-size: 100%;\n    font-weight: $vue-ms-tag-font-weight;\n  }\n\n  .multiselect__tag span {\n    @include truncate($title-truncate-width);\n  }\n\n  .multiselect__tag-icon {\n    cursor: pointer;\n    margin-left: $vue-ms-tag-padding-y;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    font-style: initial;\n    width: $vue-ms-tag-icon-size;\n    text-align: center;\n    line-height: 1.275rem;\n    transition: all 0.2s ease;\n    font-size: 50%;\n    font-weight: $vue-ms-tag-font-weight;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .multiselect__tag-icon::after {\n    content: \"×\";\n    color: $vue-ms-tag-icon-color;\n    font-size: 343%;\n    font-weight: 500;\n  }\n\n  .multiselect__tag-icon:focus,\n  .multiselect__tag-icon:hover {\n    background: $vue-ms-tag-icon-bg-hover;\n  }\n\n  .multiselect__tag-icon:focus::after,\n  .multiselect__tag-icon:hover::after {\n    color: $vue-ms-tag-icon-color-hover;\n  }\n\n  .multiselect__current {\n    line-height: $vue-ms-min-height / 2;\n    min-height: $vue-ms-min-height;\n    box-sizing: border-box;\n    display: block;\n    overflow: hidden;\n    padding: 8px 30px 0 12px;\n    white-space: nowrap;\n    margin: 0;\n    text-decoration: none;\n    border-radius: $vue-ms-border-radius;\n    border: 1px solid $vue-ms-border-color;\n    cursor: pointer;\n  }\n\n  .multiselect__select {\n    line-height: $vue-ms-min-height / 2;\n    display: block;\n    position: absolute;\n    box-sizing: border-box;\n    width: $vue-ms-min-height;\n    height: $vue-ms-min-height;\n    right: 0;\n    top: 0;\n    padding: ($vue-ms-arrow-padding) $vue-ms-arrow-padding;\n    margin: 0;\n    text-decoration: none;\n    text-align: center;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    z-index: 2;\n  }\n\n  .multiselect__select::before {\n    position: relative;\n    right: 0;\n    top: 70%;\n    color: $vue-ms-arrow-color;\n    border-style: solid;\n    border-width: $vue-ms-arrow-size $vue-ms-arrow-size 0 $vue-ms-arrow-size;\n    border-color: $vue-ms-arrow-color transparent transparent transparent;\n    content: \"\";\n  }\n\n  .multiselect__placeholder {\n    color: $vue-ms-placeholder-color;\n    display: inline-block;\n    margin-bottom: 6px;\n    padding-top: $vue-ms-padding-y;\n    line-height: 1;\n  }\n\n  .multiselect--active .multiselect__placeholder {\n    display: none;\n  }\n\n  .multiselect__content-wrapper {\n    position: absolute;\n    display: block;\n    background: $vue-ms-bg;\n    width: auto;\n    min-width: 100%;\n    max-height: 240px;\n    max-width: 100%;\n    overflow: auto;\n    border: $vue-ms-border-width solid $vue-ms-border-color;\n    margin-top: -1px;\n    border-bottom-left-radius: $vue-ms-border-radius;\n    border-bottom-right-radius: $vue-ms-border-radius;\n    z-index: 50;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .multiselect__content {\n    list-style: none;\n    display: inline-block;\n    padding: 0;\n    margin: 0;\n    min-width: 100%;\n    max-width: 100%;\n    vertical-align: top;\n  }\n\n  .multiselect--above .multiselect__content-wrapper {\n    bottom: 100%;\n    border-radius: $vue-ms-border-radius $vue-ms-border-radius 0 0;\n    border-bottom: none;\n    border-top: $vue-ms-border-width solid $vue-ms-border-color;\n  }\n\n  .multiselect__content::-webkit-scrollbar {\n    display: none;\n  }\n\n  .multiselect__element {\n    display: block;\n  }\n\n  .multiselect__option {\n    display: block;\n    padding: $vue-ms-padding-y $vue-ms-padding-x;\n    min-height: 0;\n    line-height: 1.5rem;\n    text-decoration: none;\n    text-transform: none;\n    position: relative;\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .multiselect__option::after {\n    top: 0;\n    right: 0;\n    position: absolute;\n    line-height: $vue-ms-min-height;\n    padding-right: 12px;\n    padding-left: 20px;\n    font-family: inherit;\n    font-size: inherit;\n  }\n\n  .checkbox_parent {\n    pointer-events: none;\n    display: flex;\n    align-items: center;\n  }\n\n  .multiselect__checkbox {\n    margin-right: 9px;\n  }\n\n  .multiselect__checkbox + span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  .multiselect__option--highlight {\n    background: $vue-ms-option-highlight-bg;\n    outline: none;\n    color: $vue-ms-option-highlight-color;\n  }\n\n  .multiselect__option--highlight::after {\n    content: attr(data-select);\n    background: $vue-ms-option-highlight-bg;\n    color: $vue-ms-option-highlight-color;\n  }\n\n  .multiselect__option--selected {\n    background: $vue-ms-option-selected-bg;\n    color: $vue-ms-option-selected-color;\n    font-weight: normal;\n  }\n\n  .multiselect__option--selected::after {\n    content: attr(data-selected);\n    color: $color-white;\n  }\n\n  .multiselect__option--selected.multiselect__option--highlight {\n    background: $vue-ms-option-selected-highlight-bg;\n    color: $vue-ms-option-selected-highlight-color;\n  }\n\n  .multiselect__option--selected.multiselect__option--highlight::after {\n    background: $vue-ms-option-selected-highlight-bg;\n    content: attr(data-deselect);\n    color: $vue-ms-option-selected-highlight-color;\n  }\n\n  .multiselect__option--disabled {\n    background: $vue-ms-disabled-bg;\n    color: $vue-ms-disabled-color;\n    cursor: text;\n    pointer-events: none;\n  }\n\n  .multiselect__option--group {\n    background: $vue-ms-disabled-bg;\n    color: $vue-ms-disabled-color;\n\n    &.multiselect__option--highlight {\n      background: $vue-ms-disabled-color;\n      color: $vue-ms-disabled-bg;\n    }\n\n    &.multiselect__option--highlight::after {\n      background: $vue-ms-disabled-color;\n    }\n  }\n\n  .multiselect__option--disabled.multiselect__option--highlight {\n    background: $vue-ms-disabled-bg;\n  }\n\n  .multiselect__option--group-selected.multiselect__option--highlight {\n    background: $vue-ms-option-selected-highlight-bg;\n    color: $vue-ms-option-selected-highlight-color;\n  }\n\n  .multiselect__option--group-selected.multiselect__option--highlight::after {\n    background: $vue-ms-option-selected-highlight-bg;\n    content: attr(data-deselect);\n    color: $vue-ms-option-selected-highlight-color;\n  }\n\n  .multiselect__action {\n    &:hover {\n      color: $primary;\n    }\n    &.disabled {\n      color: $custom-select-disabled-color;\n      cursor: default;\n    }\n  }\n\n  .multiselect-enter-active,\n  .multiselect-leave-active {\n    transition: all 0.15s ease;\n  }\n\n  .multiselect-enter,\n  .multiselect-leave-active {\n    opacity: 0;\n  }\n\n  .multiselect__strong {\n    margin-bottom: $vue-ms-padding-y;\n    line-height: $vue-ms-min-height / 2;\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  .multiselect__clear-button {\n    position: absolute;\n    height: 100%;\n    right: 30px;\n    padding: 2px 0;\n    font-size: 1.3em;\n    z-index: 10;\n    cursor: pointer;\n  }\n\n  // --------------------------------\n  // Spinner\n  // --\n\n  .multiselect__spinner {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: $vue-ms-min-height;\n    height: $vue-ms-min-height;\n    background: $vue-ms-disabled-bg;\n    display: block;\n\n    &::before,\n    &::after {\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      margin: $vue-ms-spinner-margin 0 0 $vue-ms-spinner-margin;\n      width: $vue-ms-spinner-size;\n      height: $vue-ms-spinner-size;\n      border-radius: 100%;\n      border: $vue-ms-spinner-thickness solid transparent;\n      border-top-color: $vue-ms-spinner-color;\n      box-shadow: 0 0 0 1px transparent;\n    }\n\n    &::before {\n      animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);\n      animation-iteration-count: infinite;\n    }\n\n    &::after {\n      animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);\n      animation-iteration-count: infinite;\n    }\n  }\n\n  @keyframes spinning {\n    from {\n      transform: rotate(0);\n    }\n\n    to {\n      transform: rotate(2turn);\n    }\n  }\n\n  // --------------------------------\n  // Loading state\n  // --\n\n  .multiselect__loading-enter-active,\n  .multiselect__loading-leave-active {\n    transition: opacity 0.4s ease-in-out;\n    opacity: 1;\n  }\n\n  .multiselect__loading-enter,\n  .multiselect__loading-leave-active {\n    opacity: 0;\n  }\n\n  // --------------------------------\n  // RTL adjustments\n  // --\n\n  *[dir=\"rtl\"] {\n    .multiselect {\n      text-align: right;\n    }\n\n    .multiselect__select {\n      right: auto;\n      left: 1px;\n    }\n\n    .multiselect__tags {\n      padding: $vue-ms-padding-y $vue-ms-padding-y 0 $vue-ms-min-height;\n    }\n\n    .multiselect__content {\n      text-align: right;\n    }\n\n    .multiselect__option::after {\n      right: auto;\n      left: 0;\n    }\n\n    .multiselect__clear {\n      right: auto;\n      left: 12px;\n    }\n\n    .multiselect__spinner {\n      right: auto;\n      left: 1px;\n    }\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export default __vue_component__;
